// // import React, { useEffect, useMemo, useState } from "react";
// // import styled from "styled-components";
// // import Navbar from "./Navbar";
// // import DashboardHeader from "./DashboardHeader";
// // import api from "../api";

// // /* ================= HELPERS ================= */
// // const formatValue = (value, fallback = "—") => {
// //   if (value === null || value === undefined || value === "") return fallback;
// //   return value;
// // };

// // const scoreValue = (value) => {
// //   if (value === null || value === undefined || value === "") return "—";
// //   return value;
// // };

// // const safeNumber = (value) => {
// //   const num = Number(value);
// //   return Number.isNaN(num) ? 0 : num;
// // };

// // const downloadBlob = (content, filename, type) => {
// //   const blob = new Blob([content], { type });
// //   const url = URL.createObjectURL(blob);
// //   const link = document.createElement("a");
// //   link.href = url;
// //   link.download = filename;
// //   link.click();
// //   URL.revokeObjectURL(url);
// // };

// // const toCSVValue = (value) => {
// //   const stringValue = String(value ?? "");
// //   return `"${stringValue.replace(/"/g, '""')}"`;
// // };

// // /* ================= THEME UTILITY ================= */
// // const getThemeColors = (variant) => {
// //   switch (variant) {
// //     case "orange":
// //       return { 
// //         thBg: "#fff7ed", thText: "#9a3412", border: "#fed7aa", rowBg: "#ffedd5", 
// //         heading: "linear-gradient(135deg, #7c2d12, #ea580c)", pillBg: "#ffedd5", pillText: "#ea580c" 
// //       };
// //     case "purple":
// //       return { 
// //         thBg: "#f5f3ff", thText: "#5b21b6", border: "#ddd6fe", rowBg: "#ede9fe", 
// //         heading: "linear-gradient(135deg, #4c1d95, #8b5cf6)", pillBg: "#ede9fe", pillText: "#7c3aed" 
// //       };
// //     case "green":
// //       return { 
// //         thBg: "#f0fdf4", thText: "#15803d", border: "#bbf7d0", rowBg: "#dcfce7", 
// //         heading: "linear-gradient(135deg, #14532d, #22c55e)", pillBg: "#dcfce7", pillText: "#16a34a" 
// //       };
// //     case "dark":
// //       return {
// //         thBg: "#f8fafc", thText: "#0f172a", border: "#e2e8f0", rowBg: "#f1f5f9",
// //         heading: "linear-gradient(135deg, #0f172a, #334155)", pillBg: "#e2e8f0", pillText: "#0f172a"
// //       };
// //     case "red": 
// //       return {
// //         thBg: "#fef2f2", thText: "#991b1b", border: "#fca5a5", rowBg: "#fee2e2",
// //         heading: "linear-gradient(135deg, #7f1d1d, #ef4444)", pillBg: "#fee2e2", pillText: "#dc2626"
// //       };
// //     default: // Blue
// //       return { 
// //         thBg: "#eff6ff", thText: "#1e40af", border: "#bfdbfe", rowBg: "#dbeafe", 
// //         heading: "linear-gradient(135deg, #1e3a8a, #3b82f6)", pillBg: "#dbeafe", pillText: "#2563eb" 
// //       };
// //   }
// // };

// // /* ================= LAYOUT ================= */
// // const Container = styled.div`
// //   --sidebar-expanded: 260px;
// //   --sidebar-collapsed: 90px;
// //   --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
// //   --card-bg: rgba(255, 255, 255, 0.96);
// //   --text-main: #0f172a;
// //   --text-soft: #64748b;
// //   --border: rgba(148, 163, 184, 0.18);
// //   --shadow-lg: 0 22px 55px rgba(15, 23, 42, 0.08);

// //   min-height: 100vh;
// //   background: var(--page-bg);
// //   color: var(--text-main);
// //   margin-left: ${({ collapsed }) =>
// //     collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
// //   transition: margin-left 0.3s ease, background 0.3s ease;

// //   @media (max-width: 1024px) {
// //     margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")};
// //   }

// //   @media (max-width: 768px) {
// //     margin-left: 0;
// //   }
// // `;

// // const Main = styled.main`
// //   width: min(1450px, calc(100% - 32px));
// //   margin: 0 auto;
// //   padding: 90px 24px 60px; 

// //   @media (max-width: 1024px) {
// //     width: min(100%, calc(100% - 24px));
// //     padding: 84px 20px 40px;
// //   }

// //   @media (max-width: 576px) {
// //     width: min(100%, calc(100% - 16px));
// //     padding: 80px 16px 28px;
// //   }
// // `;

// // /* ================= HERO & EXPORT ================= */
// // const HeroSection = styled.div`
// //   display: flex;
// //   align-items: center;
// //   gap: 24px;
// //   margin-bottom: 24px;

// //   @media (max-width: 900px) {
// //     flex-direction: column;
// //     align-items: stretch;
// //   }
// // `;

// // const HeroPanel = styled.div`
// //   flex: 1;
// //   background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
// //   color: white;
// //   padding: 28px;
// //   border-radius: 28px;
// //   box-shadow: var(--shadow-lg);
// //   position: relative;
// //   overflow: hidden;
// //   display: flex;
// //   flex-direction: column;
// //   justify-content: center;

// //   &::before {
// //     content: "";
// //     position: absolute;
// //     right: -30px;
// //     bottom: -60px;
// //     width: 180px;
// //     height: 180px;
// //     border-radius: 50%;
// //     background: rgba(255, 255, 255, 0.08);
// //   }
// // `;

// // const HeroTitle = styled.h1`
// //   margin: 0;
// //   font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem);
// //   line-height: 1.1;
// //   font-weight: 800;
// //   margin-bottom: 10px;
// //   position: relative;
// //   z-index: 1;
// // `;

// // const HeroText = styled.p`
// //   margin: 0;
// //   color: rgba(255, 255, 255, 0.9);
// //   line-height: 1.65;
// //   font-size: 1.05rem;
// //   position: relative;
// //   z-index: 1;
// // `;

// // const ExportWrap = styled.div`
// //   display: grid;
// //   grid-template-columns: 1fr 1fr;
// //   gap: 12px;
// //   min-width: 280px;

// //   @media (max-width: 900px) {
// //     display: flex;
// //     flex-wrap: wrap;
// //   }
// // `;

// // const ExportButton = styled.button`
// //   appearance: none;
// //   border: none;
// //   outline: none;
// //   border-radius: 12px;
// //   padding: 14px 16px;
// //   background: ${({ variant }) =>
// //     variant === "primary"
// //       ? "linear-gradient(135deg, #1d4ed8, #3b82f6)"
// //       : "white"};
// //   color: ${({ variant, disabled }) => (disabled ? "#94a3b8" : variant === "primary" ? "white" : "#0f172a")};
// //   border: ${({ variant, disabled }) => (disabled ? "1px solid #e2e8f0" : variant === "primary" ? "none" : "1px solid #cbd5e1")};
// //   box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 4px 12px rgba(37, 99, 235, 0.2)" : "0 2px 4px rgba(15, 23, 42, 0.05)")};
// //   font-size: 14px;
// //   font-weight: 800;
// //   cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
// //   transition: transform 0.2s ease, box-shadow 0.2s ease;
// //   text-align: center;

// //   &:hover {
// //     transform: ${({ disabled }) => (disabled ? "none" : "translateY(-2px)")};
// //     box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 6px 16px rgba(37, 99, 235, 0.3)" : "0 4px 8px rgba(15, 23, 42, 0.1)")};
// //   }

// //   @media (max-width: 900px) {
// //     flex: 1;
// //     min-width: 120px;
// //   }
// // `;

// // /* ================= ACCORDION LIST STYLES ================= */
// // const RecordList = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   gap: 16px;
// // `;

// // const RecordItem = styled.div`
// //   background: white;
// //   border-radius: 20px;
// //   border: 1px solid ${({ $expanded }) => ($expanded ? "#bfdbfe" : "#e2e8f0")};
// //   box-shadow: ${({ $expanded }) => ($expanded ? "0 12px 30px rgba(37, 99, 235, 0.08)" : "0 4px 12px rgba(15, 23, 42, 0.03)")};
// //   overflow: hidden;
// //   transition: all 0.3s ease;
// // `;

// // const RecordHeader = styled.div`
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   padding: 20px 24px;
// //   background: ${({ $expanded }) => ($expanded ? "#eff6ff" : "white")};
// //   cursor: pointer;
// //   transition: background 0.2s ease;

// //   &:hover {
// //     background: #f8fafc;
// //   }

// //   @media (max-width: 576px) {
// //     flex-direction: column;
// //     align-items: flex-start;
// //     gap: 16px;
// //     padding: 16px;
// //   }
// // `;

// // const RecordHeaderInfo = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   gap: 6px;
// // `;

// // const RecordHeaderTitle = styled.h3`
// //   margin: 0;
// //   font-size: 1.15rem;
// //   font-weight: 800;
// //   color: #0f172a;
// // `;

// // const RecordHeaderSub = styled.p`
// //   margin: 0;
// //   font-size: 0.9rem;
// //   color: #64748b;
// //   font-weight: 600;
// // `;

// // const ViewButton = styled.button`
// //   appearance: none;
// //   background: ${({ $expanded }) => ($expanded ? "#e2e8f0" : "linear-gradient(135deg, #1d4ed8, #3b82f6)")};
// //   color: ${({ $expanded }) => ($expanded ? "#475569" : "white")};
// //   border: none;
// //   padding: 10px 24px;
// //   border-radius: 12px;
// //   font-weight: 800;
// //   font-size: 0.95rem;
// //   cursor: pointer;
// //   transition: transform 0.2s ease;

// //   &:hover {
// //     transform: translateY(-2px);
// //   }

// //   @media (max-width: 576px) {
// //     width: 100%;
// //   }
// // `;

// // const DocumentWrapper = styled.div`
// //   padding: 28px;
// //   border-top: 1px solid #e2e8f0;
// //   background: white;

// //   @media (max-width: 576px) {
// //     padding: 16px;
// //   }
// // `;

// // /* ================= DOCUMENT INNER STYLES ================= */
// // const DocumentTop = styled.div`
// //   border-bottom: 2px solid #e2e8f0;
// //   padding-bottom: 18px;
// //   margin-bottom: 22px;
// // `;

// // const DocTitle = styled.h2`
// //   font-size: clamp(1.3rem, 1.1rem + 0.6vw, 1.7rem);
// //   font-weight: 800;
// //   color: #0f172a;
// //   margin: 0 0 10px;
// // `;

// // const PeriodRow = styled.div`
// //   display: flex;
// //   flex-wrap: wrap;
// //   gap: 12px;
// // `;

// // const Pill = styled.div`
// //   display: inline-flex;
// //   align-items: center;
// //   padding: 8px 12px;
// //   background: ${(props) => props.bg || "#eff6ff"}; 
// //   color: ${(props) => props.color || "#1d4ed8"}; 
// //   border-radius: 999px;
// //   font-size: 13px;
// //   font-weight: 700;
// // `;

// // const SectionBlock = styled.section`
// //   margin-top: 28px;
// // `;

// // const SectionHeading = styled.div`
// //   background: ${({ variant }) => getThemeColors(variant).heading};
// //   color: white;
// //   border-radius: 16px;
// //   padding: 14px 18px;
// //   margin-bottom: 16px;
// // `;

// // const SectionTitle = styled.h3`
// //   font-size: 18px;
// //   font-weight: 800;
// //   margin: 0 0 4px;
// // `;

// // const SectionSub = styled.p`
// //   font-size: 13px;
// //   margin: 0;
// //   opacity: 0.9;
// // `;

// // const NoticeBox = styled.div`
// //   border: 1px solid #dbeafe;
// //   background: #f8fbff;
// //   color: #334155;
// //   border-radius: 14px;
// //   padding: 16px;
// //   margin-bottom: 18px;
// //   line-height: 1.6;
// //   font-size: 14px;
// // `;

// // const ScaleGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
// //   gap: 10px;
// //   margin-bottom: 18px;
// // `;

// // const ScaleItem = styled.div`
// //   border: 1px solid #e5e7eb;
// //   border-radius: 12px;
// //   padding: 12px;
// //   background: #fafafa;
// // `;

// // const ScaleScore = styled.div`
// //   font-size: 22px;
// //   font-weight: 800;
// //   color: #0f172a;
// // `;

// // const ScaleText = styled.div`
// //   font-size: 13px;
// //   color: #475569;
// // `;

// // /* ================= DESKTOP TABLE ================= */
// // const TableWrap = styled.div`
// //   overflow-x: auto;
// //   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
// //   border-radius: 16px;
// //   margin-bottom: 18px;

// //   @media (max-width: 900px) {
// //     display: none;
// //   }
// // `;

// // const Table = styled.table`
// //   width: 100%;
// //   min-width: 1200px;
// //   border-collapse: collapse;

// //   th, td {
// //     border-bottom: 1px solid #e5e7eb;
// //     vertical-align: top;
// //     padding: 12px;
// //     text-align: left;
// //     font-size: 14px;
// //   }
// // `;

// // const ThemedTh = styled.th`
// //   background: ${({ variant }) => getThemeColors(variant).thBg};
// //   color: ${({ variant }) => getThemeColors(variant).thText};
// //   font-weight: 800;
// //   white-space: nowrap;
// //   border-bottom: 2px solid ${({ variant }) => getThemeColors(variant).border};
// //   border-right: 1px solid ${({ variant }) => getThemeColors(variant).border};
// //   padding: 12px;
// //   text-align: left;
// //   font-size: 14px;
// //   &:last-child { border-right: none; }
// // `;

// // const WeeklyRow = styled.tr`
// //   background: #fef2f2; 
// //   td { font-size: 13px; color: #334155; }
// // `;

// // const ThemedTotalsRow = styled.tr`
// //   background: ${({ variant }) => getThemeColors(variant).rowBg};
// //   td { font-weight: 800; color: ${({ variant }) => getThemeColors(variant).thText}; }
// // `;

// // const DisabledInput = styled.div`
// //   min-height: 42px;
// //   border: 1px solid #e2e8f0;
// //   background: #f8fafc;
// //   color: #334155;
// //   border-radius: 10px;
// //   padding: 10px 12px;
// //   line-height: 1.5;
// //   white-space: pre-wrap;
// // `;

// // const SmallScore = styled.div`
// //   width: 46px;
// //   min-height: 42px;
// //   display: inline-flex;
// //   align-items: center;
// //   justify-content: center;
// //   border-radius: 10px;
// //   border: 1px solid #dbe3ee; 
// //   background: ${(props) => (props.muted ? "#f8fafc" : "#eef2ff")}; 
// //   font-weight: 800;
// //   color: #0f172a;
// // `;

// // /* ================= MOBILE/TABLET CARDS ================= */
// // const CardGrid = styled.div`
// //   display: none;

// //   @media (max-width: 900px) {
// //     display: grid;
// //     gap: 16px;
// //     margin-bottom: 18px;
// //   }
// // `;

// // const RecordCard = styled.div`
// //   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
// //   border-left: 5px solid ${({ variant }) => getThemeColors(variant).pillText};
// //   background: ${({ variant }) => getThemeColors(variant).thBg};
// //   border-radius: 18px;
// //   padding: 16px;
// //   box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
// // `;

// // const RecordCardHead = styled.div`
// //   display: flex;
// //   justify-content: space-between;
// //   gap: 10px;
// //   align-items: flex-start;
// //   flex-wrap: wrap;
// //   margin-bottom: 14px;
// // `;

// // const RecordIndex = styled.div`
// //   width: 34px;
// //   height: 34px;
// //   border-radius: 50%;
// //   background: ${({ variant }) => getThemeColors(variant).pillBg};
// //   color: ${({ variant }) => getThemeColors(variant).pillText};
// //   display: grid;
// //   place-items: center;
// //   font-weight: 800;
// // `;

// // const RecordLabel = styled.div`
// //   font-size: 12px;
// //   font-weight: 800;
// //   text-transform: uppercase;
// //   letter-spacing: 0.04em;
// //   color: ${({ variant }) => getThemeColors(variant).pillText};
// // `;

// // const RecordFields = styled.div`
// //   display: grid;
// //   gap: 12px;
// // `;

// // const FieldBlock = styled.div``;

// // const FieldTitle = styled.div`
// //   font-size: 12px;
// //   font-weight: 800;
// //   color: #64748b;
// //   text-transform: uppercase;
// //   letter-spacing: 0.04em;
// //   margin-bottom: 6px;
// // `;

// // const CompactScoreGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: repeat(2, minmax(0, 1fr));
// //   gap: 10px;
// //   @media (max-width: 420px) { grid-template-columns: 1fr; }
// // `;

// // const WeeklyCard = styled.div`
// //   margin-top: 10px;
// //   padding: 12px;
// //   background: #fef2f2;
// //   border-left: 4px solid #ef4444; 
// //   border-radius: 12px;
// // `;

// // /* ================= SUMMARY ================= */
// // const SummaryGrid = styled.div`
// //   display: grid;
// //   grid-template-columns: 1.2fr 1fr;
// //   gap: 18px;

// //   @media (max-width: 980px) {
// //     grid-template-columns: 1fr;
// //   }
// // `;

// // const SummaryCard = styled.div`
// //   border: 1px solid #e5e7eb;
// //   border-radius: 16px;
// //   padding: 24px;
// //   background: white;
// //   display: flex;
// //   flex-direction: column;
// // `;

// // const SummaryCardTitle = styled.h4`
// //   margin: 0 0 16px;
// //   font-size: 1.1rem;
// //   font-weight: 800;
// //   color: #0f172a;
// // `;

// // const ScoreList = styled.div`
// //   display: grid;
// //   gap: 12px;
// // `;

// // const ScoreRow = styled.div`
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   gap: 12px;
// //   padding: 14px 18px;
// //   border-radius: 12px;
// //   background: ${({ variant }) => getThemeColors(variant).thBg};
// //   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
// // `;

// // const ScoreLabel = styled.div`
// //   font-size: 14px;
// //   font-weight: 700;
// //   color: ${({ variant }) => getThemeColors(variant).thText};
// // `;

// // const ScoreValueBox = styled.div`
// //   font-size: 1.1rem;
// //   font-weight: 900;
// //   color: ${({ variant }) => getThemeColors(variant).thText};
// // `;

// // const BigGrade = styled.div`
// //   font-size: clamp(2rem, 1.8rem + 1vw, 2.6rem);
// //   font-weight: 900;
// //   color: #1d4ed8; 
// // `;

// // const TextBlock = styled.div`
// //   flex: 1;
// //   min-height: 110px;
// //   border: 1px solid #e2e8f0;
// //   border-radius: 14px;
// //   background: #f8fafc;
// //   padding: 16px;
// //   white-space: pre-wrap;
// //   line-height: 1.7;
// //   color: #334155;
// // `;

// // const GradeTable = styled.table`
// //   width: 100%;
// //   border-collapse: collapse;
// //   border-radius: 12px;
// //   overflow: hidden;
// //   border: 1px solid #bfdbfe; 
// //   font-size: 0.9rem;
// //   background: white;
// //   margin-top: auto;

// //   th {
// //     background: linear-gradient(135deg, #1e3a8a, #2563eb); 
// //     color: white;
// //     font-weight: 800;
// //     padding: 14px;
// //     text-align: left;
// //     border-bottom: 2px solid #1e40af; 
// //   }
// //   td {
// //     padding: 12px 14px;
// //     border-bottom: 1px solid #dbeafe; 
// //     color: #1e3a8a; 
// //     font-weight: 700;
// //   }
// //   tr:last-child td { border-bottom: none; }
// // `;

// // /* ================= LOADING / EMPTY STATES ================= */
// // const CenterState = styled.div`
// //   min-height: 60vh;
// //   display: grid;
// //   place-items: center;
// //   padding: 24px;
// // `;

// // const StateCard = styled.div`
// //   width: min(460px, 100%);
// //   background: rgba(255, 255, 255, 0.95);
// //   border: 1px solid var(--border);
// //   border-radius: 24px;
// //   padding: 28px;
// //   text-align: center;
// //   box-shadow: var(--shadow-md);
// // `;

// // const Spinner = styled.div`
// //   width: 46px;
// //   height: 46px;
// //   margin: 0 auto 18px;
// //   border-radius: 50%;
// //   border: 4px solid #dbeafe;
// //   border-top-color: #2563eb;
// //   animation: spin 0.8s linear infinite;

// //   @keyframes spin {
// //     to { transform: rotate(360deg); }
// //   }
// // `;

// // const StateTitle = styled.h3`
// //   margin: 0;
// //   font-size: 1.1rem;
// //   color: #0f172a;
// // `;

// // const StateText = styled.p`
// //   margin: 10px 0 0;
// //   color: var(--text-soft);
// //   line-height: 1.6;
// // `;

// // const EmptyState = styled.div`
// //   text-align: center;
// //   padding: 90px 20px;
// //   color: #64748b;
// //   background: white;
// //   border-radius: 20px;
// //   border: 1px dashed #cbd5e1;
// // `;

// // /* ================= COMPONENT ================= */
// // const Records = ({ user, collapsed, setCollapsed }) => {
// //   const [records, setRecords] = useState([]);
// //   const [loading, setLoading] = useState(true);
  
// //   // Track which record is currently expanded
// //   const [expandedId, setExpandedId] = useState("");

// //   useEffect(() => {
// //     const fetchRecords = async () => {
// //       try {
// //         const res = await api.get("/appraisal/all");
// //         setRecords(res.data?.data || []);
// //       } catch (err) {
// //         console.error("Failed to fetch records", err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchRecords();
// //   }, []);

// //   // Dynamically generate the flat list of records (Year/Month)
// //   const allTabs = useMemo(() => {
// //     const tabs = [];
// //     records.forEach((record) => {
// //       const yearMatch = record.appraisalPeriod.match(/\d{4}/);
// //       const year = yearMatch ? yearMatch[0] : ""; 
      
// //       (record.section2 || []).forEach((m) => {
// //         const monthName = m.month || "Unknown";
// //         const displayYear = (year && !monthName.includes(year)) ? ` ${year}` : "";
        
// //         tabs.push({
// //           id: `${record.appraisalPeriod}-${monthName}`,
// //           period: record.appraisalPeriod,
// //           month: monthName,
// //           label: `Performance Record for ${monthName}${displayYear}`,
// //           record: record, 
// //           monthData: m    
// //         });
// //       });
// //     });
// //     return tabs;
// //   }, [records]);

// //   // Find the active tab's data for EXPORT ONLY
// //   const currentTab = useMemo(() => {
// //     return allTabs.find(tab => tab.id === expandedId) || null;
// //   }, [allTabs, expandedId]);

// //   const exportData = useMemo(() => {
// //     if (!currentTab) return null;
// //     return {
// //       appraisalPeriod: currentTab.record.appraisalPeriod,
// //       selectedMonth: currentTab.month,
// //       section2: currentTab.monthData || null,
// //       section3: currentTab.record.section3 || [],
// //       section4: currentTab.record.section4 || [],
// //       summary: currentTab.record.summary || {},
// //       staffFeedback: currentTab.record.staffFeedback || {},
// //     };
// //   }, [currentTab]);

// //   const exportBaseName = `performance-record-${currentTab?.period || "record"}-${currentTab?.month || "month"}`;

// //   const handleExportJSON = () => {
// //     if (!exportData) return;
// //     downloadBlob(JSON.stringify(exportData, null, 2), `${exportBaseName}.json`, "application/json");
// //   };

// //   const handleExportTXT = () => {
// //     if (!exportData) return;
// //     const txt = `
// // PERFORMANCE RECORD
// // Period: ${currentTab.period}
// // Month: ${currentTab.month}

// // SUMMARY
// // Section 2: ${formatValue(exportData.summary?.section2, 0)}
// // Section 3: ${formatValue(exportData.summary?.section3, 0)}
// // Section 4: ${formatValue(exportData.summary?.section4, 0)}
// // Cumulative: ${formatValue(exportData.summary?.cumulative, 0)}
// // Grade: ${formatValue(exportData.summary?.grade, "—")}
// // Supervisor Grade: ${formatValue(exportData.summary?.supervisorGrade, "—")}

// // CITATION
// // ${formatValue(exportData.summary?.citation)}

// // SUPERVISOR OVERALL COMMENTS
// // ${formatValue(exportData.staffFeedback?.supervisorAttention)}
// //     `.trim();

// //     downloadBlob(txt, `${exportBaseName}.txt`, "text/plain;charset=utf-8");
// //   };

// //   const handleExportCSV = () => {
// //     if (!exportData) return;
// //     const rows = [];
// //     rows.push(["section", "group", "title", "achievement", "staffActionScore", "staffQualityScore", "supervisorActionScore", "supervisorQualityScore", "staffScore", "supervisorScore", "comments"].map(toCSVValue).join(","));

// //     (exportData.section2?.majorGoals || []).forEach((item) => {
// //       rows.push(["Section 2", "Major Goal", item.goal, item.achievement, item.staffActionScore, item.staffQualityScore, item.supervisorActionScore, item.supervisorQualityScore, "", "", item.supervisorComments].map(toCSVValue).join(","));
// //     });

// //     (exportData.section2?.otherGoals || []).forEach((item) => {
// //       rows.push(["Section 2", "Other Goal", item.goal, item.achievement, item.staffActionScore, item.staffQualityScore, item.supervisorActionScore, item.supervisorQualityScore, "", "", item.supervisorComments].map(toCSVValue).join(","));
// //     });

// //     (exportData.section3 || []).forEach((item) => {
// //       rows.push(["Section 3", "Work Ethic", item.attribute, "", "", "", "", "", item.staffScore, item.supervisorScore, item.supervisorComments].map(toCSVValue).join(","));
// //     });

// //     (exportData.section4 || []).forEach((item) => {
// //       rows.push(["Section 4", "Compliance", item.attribute, "", "", "", "", "", item.staffScore, item.supervisorScore, item.supervisorComments].map(toCSVValue).join(","));
// //     });

// //     downloadBlob(rows.join("\n"), `${exportBaseName}.csv`, "text/csv;charset=utf-8");
// //   };

// //   const handlePrintPDF = () => window.print();

// //   if (loading) {
// //     return (
// //       <Container collapsed={collapsed}>
// //         <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// //         <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
// //         <CenterState>
// //           <StateCard>
// //             <Spinner />
// //             <StateTitle>Loading performance records</StateTitle>
// //             <StateText>Please wait while your performance and evaluation records are being prepared.</StateText>
// //           </StateCard>
// //         </CenterState>
// //       </Container>
// //     );
// //   }

//   // if (!records.length || allTabs.length === 0) {
//   //   return (
//   //     <Container collapsed={collapsed}>
//   //       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//   //       <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
//   //       <Main>
//   //         <EmptyState>No records found yet.</EmptyState>
//   //       </Main>
//   //     </Container>
//   //   );
//   // }

// //   return (
// //     <Container collapsed={collapsed}>
// //       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// //       <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />

// //       <Main>
        
// //         {/* NEW HERO & EXPORT SECTION */}
// //         <HeroSection>
// //           <HeroPanel>
// //             <HeroTitle>Records</HeroTitle>
// //             <HeroText>View your performance records fully displayed per period.</HeroText>
// //           </HeroPanel>

// //           <ExportWrap>
// //             <ExportButton variant="primary" disabled={!expandedId} onClick={handlePrintPDF}>Print / PDF</ExportButton>
// //             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportCSV}>Export CSV</ExportButton>
// //             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportJSON}>Export JSON</ExportButton>
// //             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportTXT}>Export TXT</ExportButton>
// //           </ExportWrap>
// //         </HeroSection>

// //         {/* ACCORDION LIST OF RECORDS */}
// //         <RecordList>
// //           {allTabs.map((tab) => {
// //             const isExpanded = expandedId === tab.id;
// //             const recordData = tab.record;
// //             const monthData = tab.monthData;

// //             return (
// //               <RecordItem key={tab.id} $expanded={isExpanded}>
// //                 <RecordHeader $expanded={isExpanded} onClick={() => setExpandedId(isExpanded ? "" : tab.id)}>
// //                   <RecordHeaderInfo>
// //                     <RecordHeaderTitle>{tab.label}</RecordHeaderTitle>
// //                     <RecordHeaderSub>Period: {tab.period}</RecordHeaderSub>
// //                   </RecordHeaderInfo>
// //                   <ViewButton $expanded={isExpanded}>
// //                     {isExpanded ? "Close" : "View"}
// //                   </ViewButton>
// //                 </RecordHeader>

// //                 {/* THE 4 EXPANDABLE SEGMENTS */}
// //                 {isExpanded && (
// //                   <DocumentWrapper>
// //                     <DocumentTop>
// //                       <DocTitle>Quarterly Performance Form</DocTitle>
// //                       <PeriodRow>
// //                         <Pill>{tab.period}</Pill>
// //                         <Pill bg="#ecfeff" color="#0f766e">Displaying month: {tab.month}</Pill>
// //                         <Pill bg="#fef3c7" color="#92400e">Supervisor fields are visible but disabled</Pill>
// //                       </PeriodRow>
// //                     </DocumentTop>

// //                     {/* SECTION 2: PERFORMANCE ON GOALS */}
// //                     <SectionBlock>
// //                       <SectionHeading variant="red">
// //                         <SectionTitle>PERFORMANCE ON GOALS FOR {(tab.month || "—").toUpperCase()}</SectionTitle>
// //                         <SectionSub>Performance on Major Goals - 60 Marks / Performance on Other Goals - 15 Marks</SectionSub>
// //                       </SectionHeading>

// //                       <NoticeBox>
// //                         This section keeps the original structural format. On desktop, it displays as full tables.
// //                         On tablet and mobile, it automatically switches into stacked record cards for easier reading.
// //                       </NoticeBox>

// //                       <ScaleGrid>
// //                         {[
// //                           { score: "-", text: "N/A - Not applicable" },
// //                           { score: "0", text: "Not started / Nothing delivered" },
// //                           { score: "1", text: "39% & below / Unsatisfactory" },
// //                           { score: "2", text: "40% to 59% / Below expectation" },
// //                           { score: "3", text: "60% to 79% / Met some expectation" },
// //                           { score: "4", text: "80% to 100% / Met expectation" },
// //                           { score: "5", text: "100% above / Surpassed expectation" },
// //                         ].map((item) => (
// //                           <ScaleItem key={item.score}>
// //                             <ScaleScore>{item.score}</ScaleScore>
// //                             <ScaleText>{item.text}</ScaleText>
// //                           </ScaleItem>
// //                         ))}
// //                       </ScaleGrid>

// //                       <SectionTitle style={{ marginBottom: 12 }}>Performance on Major Goals - 60 Marks</SectionTitle>
// //                       <TableWrap variant="red">
// //                         <Table>
// //                           <thead>
// //                             <tr>
// //                               <ThemedTh variant="red">S/N</ThemedTh>
// //                               <ThemedTh variant="red">MAJOR GOALS</ThemedTh>
// //                               <ThemedTh variant="red">ACHIEVEMENTS</ThemedTh>
// //                               <ThemedTh variant="red">YOUR SCORE ON ACTIONS TAKEN (0-5)</ThemedTh>
// //                               <ThemedTh variant="red">YOUR SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
// //                               <ThemedTh variant="red">SUPERVISOR’S SCORE ON ACTIONS TAKEN (0-5)</ThemedTh>
// //                               <ThemedTh variant="red">SUPERVISOR’S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
// //                               <ThemedTh variant="red">SUPERVISOR’S COMMENTS</ThemedTh>
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {(monthData?.majorGoals || []).map((goal, index) => (
// //                               <React.Fragment key={index}>
// //                                 <tr>
// //                                   <td>{index + 1}</td>
// //                                   <td><DisabledInput>{formatValue(goal.goal)}</DisabledInput></td>
// //                                   <td><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></td>
// //                                   <td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></td>
// //                                   <td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
// //                                   <td><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
// //                                   <td><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
// //                                   <td><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></td>
// //                                 </tr>
// //                                 {(goal.weekly || []).map((week, weekIndex) => (
// //                                   <WeeklyRow key={`${index}-${weekIndex}`}>
// //                                     <td></td>
// //                                     <td>
// //                                       <strong>{formatValue(week.week, `Week ${weekIndex + 1}`)}</strong>
// //                                       <div style={{ marginTop: 8 }}>{formatValue(week.weeklyGoal)}</div>
// //                                     </td>
// //                                     <td>{formatValue(week.weeklyAchievement)}</td>
// //                                     <td colSpan="5">NO SCORES FOR WEEKLY GOALS</td>
// //                                   </WeeklyRow>
// //                                 ))}
// //                               </React.Fragment>
// //                             ))}
// //                             <ThemedTotalsRow variant="red">
// //                               <td colSpan="3">SUM OF SCORES (SS)</td>
// //                               <td>{formatValue(monthData?.majorSumA, 0)}</td>
// //                               <td>{formatValue(monthData?.majorSumQ, 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="red">
// //                               <td colSpan="3">SCORE (SS/GOALS)</td>
// //                               <td>{formatValue(monthData?.majorGoals?.length ? (safeNumber(monthData?.majorSumA) / monthData.majorGoals.length).toFixed(2) : 0)}</td>
// //                               <td>{formatValue(monthData?.majorGoals?.length ? (safeNumber(monthData?.majorSumQ) / monthData.majorGoals.length).toFixed(2) : 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="red">
// //                               <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
// //                               <td colSpan="2">{formatValue(monthData?.majorCombined, 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="red">
// //                               <td colSpan="3">TOTAL SCORE (CS/5 × 60 Marks)</td>
// //                               <td colSpan="5">{formatValue(monthData?.majorTotalMarks, 0)} / 60</td>
// //                             </ThemedTotalsRow>
// //                           </tbody>
// //                         </Table>
// //                       </TableWrap>

// //                       <CardGrid>
// //                         {(monthData?.majorGoals || []).map((goal, index) => (
// //                           <RecordCard variant="red" key={index}>
// //                             <RecordCardHead>
// //                               <RecordIndex variant="red">{index + 1}</RecordIndex>
// //                               <RecordLabel variant="red">Major Goal</RecordLabel>
// //                             </RecordCardHead>
// //                             <RecordFields>
// //                               <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
// //                               <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
// //                               <CompactScoreGrid>
// //                                 <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
// //                               </CompactScoreGrid>
// //                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
// //                               {(goal.weekly || []).map((week, weekIndex) => (
// //                                 <WeeklyCard key={weekIndex}>
// //                                   <FieldTitle>{formatValue(week.week, `Week ${weekIndex + 1}`)}</FieldTitle>
// //                                   <div>{formatValue(week.weeklyGoal)}</div>
// //                                   <div style={{ marginTop: 8, color: "#64748b" }}>{formatValue(week.weeklyAchievement)}</div>
// //                                 </WeeklyCard>
// //                               ))}
// //                             </RecordFields>
// //                           </RecordCard>
// //                         ))}
// //                       </CardGrid>

// //                       <SectionTitle style={{ marginBottom: 12 }}>Performance on Other Goals - 15 Marks</SectionTitle>
// //                       <TableWrap variant="orange">
// //                         <Table>
// //                           <thead>
// //                             <tr>
// //                               <ThemedTh variant="orange">S/N</ThemedTh>
// //                               <ThemedTh variant="orange">OTHER GOALS</ThemedTh>
// //                               <ThemedTh variant="orange">ACHIEVEMENTS</ThemedTh>
// //                               <ThemedTh variant="orange">YOUR SCORE ON ACTIONS TAKEN (0-5)</ThemedTh>
// //                               <ThemedTh variant="orange">YOUR SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
// //                               <ThemedTh variant="orange">SUPERVISOR’S SCORE ON ACTIONS TAKEN (0-5)</ThemedTh>
// //                               <ThemedTh variant="orange">SUPERVISOR’S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
// //                               <ThemedTh variant="orange">SUPERVISOR’S COMMENTS</ThemedTh>
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {(monthData?.otherGoals || []).map((goal, index) => (
// //                               <tr key={index}>
// //                                 <td>{index + 1}</td>
// //                                 <td><DisabledInput>{formatValue(goal.goal)}</DisabledInput></td>
// //                                 <td><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></td>
// //                                 <td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></td>
// //                                 <td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
// //                                 <td><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
// //                                 <td><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
// //                                 <td><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></td>
// //                               </tr>
// //                             ))}
// //                             <ThemedTotalsRow variant="orange">
// //                               <td colSpan="3">SUM OF SCORES (SS)</td>
// //                               <td>{formatValue(monthData?.otherSumA, 0)}</td>
// //                               <td>{formatValue(monthData?.otherSumQ, 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="orange">
// //                               <td colSpan="3">SCORE (SS/GOALS)</td>
// //                               <td>{formatValue(monthData?.otherGoals?.length ? (safeNumber(monthData?.otherSumA) / monthData.otherGoals.length).toFixed(2) : 0)}</td>
// //                               <td>{formatValue(monthData?.otherGoals?.length ? (safeNumber(monthData?.otherSumQ) / monthData.otherGoals.length).toFixed(2) : 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="orange">
// //                               <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
// //                               <td colSpan="2">{formatValue(monthData?.otherCombined, 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="orange">
// //                               <td colSpan="3">TOTAL SCORE (CS/5 × 15 Marks)</td>
// //                               <td colSpan="5">{formatValue(monthData?.otherTotalMarks, 0)} / 15</td>
// //                             </ThemedTotalsRow>
// //                           </tbody>
// //                         </Table>
// //                       </TableWrap>

// //                       <CardGrid>
// //                         {(monthData?.otherGoals || []).map((goal, index) => (
// //                           <RecordCard variant="orange" key={index}>
// //                             <RecordCardHead>
// //                               <RecordIndex variant="orange">{index + 1}</RecordIndex>
// //                               <RecordLabel variant="orange">Other Goal</RecordLabel>
// //                             </RecordCardHead>
// //                             <RecordFields>
// //                               <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
// //                               <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
// //                               <CompactScoreGrid>
// //                                 <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
// //                               </CompactScoreGrid>
// //                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
// //                             </RecordFields>
// //                           </RecordCard>
// //                         ))}
// //                       </CardGrid>
// //                     </SectionBlock>

// //                     {/* SECTION 3: WORK ETHICS */}
// //                     <SectionBlock>
// //                       <SectionHeading variant="purple">
// //                         <SectionTitle>WORK ETHIC & LEADERSHIP ATTRIBUTES FOR {(tab.month || "—").toUpperCase()}</SectionTitle>
// //                         <SectionSub>Performance on Work Ethic & Leadership Attributes - 15 Marks</SectionSub>
// //                       </SectionHeading>

// //                       <TableWrap variant="purple">
// //                         <Table>
// //                           <thead>
// //                             <tr>
// //                               <ThemedTh variant="purple">S/N</ThemedTh>
// //                               <ThemedTh variant="purple">ATTRIBUTE</ThemedTh>
// //                               <ThemedTh variant="purple">DESCRIPTION</ThemedTh>
// //                               <ThemedTh variant="purple">YOUR SCORE (0-5)</ThemedTh>
// //                               <ThemedTh variant="purple">YOUR COMMENTS</ThemedTh>
// //                               <ThemedTh variant="purple">SUPERVISOR'S SCORE (0-5)</ThemedTh>
// //                               <ThemedTh variant="purple">SUPERVISOR’S COMMENTS</ThemedTh>
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {(recordData?.section3 || []).map((item, index) => (
// //                               <tr key={index}>
// //                                 <td>{index + 1}</td>
// //                                 <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
// //                                 <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
// //                                 <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
// //                                 <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
// //                                 <td><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></td>
// //                                 <td><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></td>
// //                               </tr>
// //                             ))}
// //                             <ThemedTotalsRow variant="purple">
// //                               <td colSpan="3">SUM OF SCORES (SS)</td>
// //                               <td>{(recordData?.section3 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="purple">
// //                               <td colSpan="3">SCORE (SS/10)</td>
// //                               <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="purple">
// //                               <td colSpan="3">TOTAL SCORE (SCORE/5 × 15 Marks)</td>
// //                               <td>{formatValue(recordData?.summary?.section3, 0)} / 15</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                           </tbody>
// //                         </Table>
// //                       </TableWrap>

// //                       <CardGrid>
// //                         {(recordData?.section3 || []).map((item, index) => (
// //                           <RecordCard variant="purple" key={index}>
// //                             <RecordCardHead>
// //                               <RecordIndex variant="purple">{index + 1}</RecordIndex>
// //                               <RecordLabel variant="purple">Work Ethic</RecordLabel>
// //                             </RecordCardHead>
// //                             <RecordFields>
// //                               <FieldBlock><FieldTitle>Attribute</FieldTitle><DisabledInput>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
// //                               <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput>{formatValue(item.description)}</DisabledInput></FieldBlock>
// //                               <CompactScoreGrid>
// //                                 <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
// //                               </CompactScoreGrid>
// //                               <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
// //                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
// //                             </RecordFields>
// //                           </RecordCard>
// //                         ))}
// //                       </CardGrid>
// //                     </SectionBlock>

// //                     {/* SECTION 4: COMPLIANCE */}
// //                     <SectionBlock>
// //                       <SectionHeading variant="green">
// //                         <SectionTitle>COMPLIANCE FOR {(tab.month || "—").toUpperCase()}</SectionTitle>
// //                         <SectionSub>Compliance - 10 Marks</SectionSub>
// //                       </SectionHeading>

// //                       <TableWrap variant="green">
// //                         <Table>
// //                           <thead>
// //                             <tr>
// //                               <ThemedTh variant="green">S/N</ThemedTh>
// //                               <ThemedTh variant="green">PROTOCOL</ThemedTh>
// //                               <ThemedTh variant="green">DESCRIPTION</ThemedTh>
// //                               <ThemedTh variant="green">YOUR SCORE (0-5)</ThemedTh>
// //                               <ThemedTh variant="green">YOUR COMMENTS</ThemedTh>
// //                               <ThemedTh variant="green">SUPERVISOR'S SCORE (0-5)</ThemedTh>
// //                               <ThemedTh variant="green">SUPERVISOR’S COMMENTS</ThemedTh>
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {(recordData?.section4 || []).map((item, index) => (
// //                               <tr key={index}>
// //                                 <td>{index + 1}</td>
// //                                 <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
// //                                 <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
// //                                 <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
// //                                 <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
// //                                 <td><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></td>
// //                                 <td><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></td>
// //                               </tr>
// //                             ))}
// //                             <ThemedTotalsRow variant="green">
// //                               <td colSpan="3">SUM OF SCORES (SS)</td>
// //                               <td>{(recordData?.section4 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="green">
// //                               <td colSpan="3">SCORE (SS/13)</td>
// //                               <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                             <ThemedTotalsRow variant="green">
// //                               <td colSpan="3">TOTAL SCORE (SCORE/5 × 10 Marks)</td>
// //                               <td>{formatValue(recordData?.summary?.section4, 0)} / 10</td>
// //                               <td colSpan="3"></td>
// //                             </ThemedTotalsRow>
// //                           </tbody>
// //                         </Table>
// //                       </TableWrap>

// //                       <CardGrid>
// //                         {(recordData?.section4 || []).map((item, index) => (
// //                           <RecordCard variant="green" key={index}>
// //                             <RecordCardHead>
// //                               <RecordIndex variant="green">{index + 1}</RecordIndex>
// //                               <RecordLabel variant="green">Compliance</RecordLabel>
// //                             </RecordCardHead>
// //                             <RecordFields>
// //                               <FieldBlock><FieldTitle>Protocol</FieldTitle><DisabledInput>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
// //                               <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput>{formatValue(item.description)}</DisabledInput></FieldBlock>
// //                               <CompactScoreGrid>
// //                                 <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
// //                                 <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
// //                               </CompactScoreGrid>
// //                               <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
// //                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
// //                             </RecordFields>
// //                           </RecordCard>
// //                         ))}
// //                       </CardGrid>
// //                     </SectionBlock>

// //                     {/* SUMMARY SECTION */}
// //                     <SectionBlock>
// //                       <SectionHeading variant="blue">
// //                         <SectionTitle>SUMMARY OF PERFORMANCE FOR {(tab.month || "—").toUpperCase()}</SectionTitle>
// //                         <SectionSub>500 character citation and supervisor scoring summary</SectionSub>
// //                       </SectionHeading>

// //                       <SummaryGrid>
// //                         <SummaryCard>
// //                           <SummaryCardTitle>500 Character Citations of Your Achievements for the Month</SummaryCardTitle>
// //                           <TextBlock>{formatValue(recordData?.summary?.citation)}</TextBlock>

// //                           <SummaryCardTitle style={{ marginTop: '24px' }}>Grading Scale</SummaryCardTitle>
// //                           <GradeTable>
// //                             <thead><tr><th>SCORE RANGE</th><th>GRADE</th></tr></thead>
// //                             <tbody>
// //                               <tr><td>80% - Above</td><td>A</td></tr>
// //                               <tr><td>70% - 79%</td><td>B</td></tr>
// //                               <tr><td>60% - 69%</td><td>C</td></tr>
// //                               <tr><td>50% - 59%</td><td>D</td></tr>
// //                               <tr><td>49% - Below</td><td>E</td></tr>
// //                             </tbody>
// //                           </GradeTable>
// //                         </SummaryCard>

// //                         <SummaryCard>
// //                           <SummaryCardTitle>Total Scores</SummaryCardTitle>
// //                           <ScoreList>
// //                             <ScoreRow variant="red">
// //                               <ScoreLabel variant="red">Performance on Goals</ScoreLabel>
// //                               <ScoreValueBox variant="red">{formatValue(recordData?.summary?.section2, 0)}</ScoreValueBox>
// //                             </ScoreRow>
// //                             <ScoreRow variant="purple">
// //                               <ScoreLabel variant="purple">Work Ethics & Leadership Attributes</ScoreLabel>
// //                               <ScoreValueBox variant="purple">{formatValue(recordData?.summary?.section3, 0)}</ScoreValueBox>
// //                             </ScoreRow>
// //                             <ScoreRow variant="green">
// //                               <ScoreLabel variant="green">Compliance</ScoreLabel>
// //                               <ScoreValueBox variant="green">{formatValue(recordData?.summary?.section4, 0)}</ScoreValueBox>
// //                             </ScoreRow>
// //                             <ScoreRow variant="dark">
// //                               <ScoreLabel variant="dark">Performance Score for the Month</ScoreLabel>
// //                               <ScoreValueBox variant="dark">{formatValue(recordData?.summary?.cumulative, 0)}</ScoreValueBox>
// //                             </ScoreRow>
// //                             <ScoreRow variant="dark">
// //                               <ScoreLabel variant="dark">Supervisor Cumulative</ScoreLabel>
// //                               <ScoreValueBox variant="dark">{formatValue(recordData?.summary?.supervisorCumulative, "—")}</ScoreValueBox>
// //                             </ScoreRow>
// //                           </ScoreList>

// //                           <div style={{ marginTop: 18, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 18, flexWrap: "wrap" }}>
// //                             <div>
// //                               <div style={{ fontSize: 13, color: "#64748b", marginBottom: 4 }}>Grade</div>
// //                               <BigGrade>{formatValue(recordData?.summary?.grade, "—")}</BigGrade>
// //                             </div>
// //                             <div>
// //                               <div style={{ fontSize: 13, color: "#64748b", marginBottom: 4 }}>Supervisor Grade</div>
// //                               <BigGrade style={{ color: "#0f766e" }}>{formatValue(recordData?.summary?.supervisorGrade, "—")}</BigGrade>
// //                             </div>
// //                           </div>
// //                         </SummaryCard>
// //                       </SummaryGrid>
// //                     </SectionBlock>

// //                     {/* SUPERVISOR COMMENTS */}
// //                     <SectionBlock>
// //                       <SectionHeading variant="blue">
// //                         <SectionTitle>SUPERVISOR’S OVERALL COMMENTS</SectionTitle>
// //                         <SectionSub>Visible for later scoring and review</SectionSub>
// //                       </SectionHeading>
// //                       <TextBlock>{formatValue(recordData?.staffFeedback?.supervisorAttention)}</TextBlock>
// //                     </SectionBlock>

// //                     <SectionBlock>
// //                       <SectionHeading variant="blue">
// //                         <SectionTitle>HEAD OF DEPARTMENT’S OVERALL COMMENTS</SectionTitle>
// //                         <SectionSub>Reserved for final review</SectionSub>
// //                       </SectionHeading>
// //                       <TextBlock>—</TextBlock>
// //                     </SectionBlock>

// //                   </DocumentWrapper>
// //                 )}
// //               </RecordItem>
// //             );
// //           })}
// //         </RecordList>

// //       </Main>
// //     </Container>
// //   );
// // };

// // export default Records;
// //Supervisor




// import React, { useEffect, useMemo, useState } from "react";
// import styled from "styled-components";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import api from "../api";
// import Footer from "./Footer";
// //60
// /* ================= HELPERS ================= */
// const formatValue = (value, fallback = "—") => {
//   if (value === null || value === undefined || value === "") return fallback;
//   return value;
// };

// const scoreValue = (value) => {
//   if (value === null || value === undefined || value === "") return "—";
//   return value;
// };

// const safeNumber = (value) => {
//   const num = Number(value);
//   return Number.isNaN(num) ? 0 : num;
// };

// const downloadBlob = (content, filename, type) => {
//   const blob = new Blob([content], { type });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = filename;
//   link.click();
//   URL.revokeObjectURL(url);
// };

// const toCSVValue = (value) => {
//   const stringValue = String(value ?? "");
//   return `"${stringValue.replace(/"/g, '""')}"`;
// };

// /* ================= THEME UTILITY ================= */
// const getThemeColors = (variant) => {
//   switch (variant) {
//     case "orange":
//       return { 
//         thBg: "#fff7ed", thText: "#9a3412", border: "#fed7aa", rowBg: "#ffedd5", 
//         heading: "linear-gradient(135deg, #7c2d12, #ea580c)", pillBg: "#ffedd5", pillText: "#ea580c" 
//       };
//     case "purple":
//       return { 
//         thBg: "#f5f3ff", thText: "#5b21b6", border: "#ddd6fe", rowBg: "#ede9fe", 
//         heading: "linear-gradient(135deg, #4c1d95, #8b5cf6)", pillBg: "#ede9fe", pillText: "#7c3aed" 
//       };
//     case "green":
//       return { 
//         thBg: "#f0fdf4", thText: "#15803d", border: "#bbf7d0", rowBg: "#dcfce7", 
//         heading: "linear-gradient(135deg, #14532d, #22c55e)", pillBg: "#dcfce7", pillText: "#16a34a" 
//       };
//     case "dark":
//       return {
//         thBg: "#f8fafc", thText: "#0f172a", border: "#e2e8f0", rowBg: "#f1f5f9",
//         heading: "linear-gradient(135deg, #0f172a, #334155)", pillBg: "#e2e8f0", pillText: "#0f172a"
//       };
//     case "red": 
//       return {
//         thBg: "#fef2f2", thText: "#991b1b", border: "#fca5a5", rowBg: "#fee2e2",
//         heading: "linear-gradient(135deg, #7f1d1d, #ef4444)", pillBg: "#fee2e2", pillText: "#dc2626"
//       };
//     default: // Blue
//       return { 
//         thBg: "#eff6ff", thText: "#1e40af", border: "#bfdbfe", rowBg: "#dbeafe", 
//         heading: "linear-gradient(135deg, #1e3a8a, #3b82f6)", pillBg: "#dbeafe", pillText: "#2563eb" 
//       };
//   }
// };

// /* ================= LAYOUT ================= */
// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
//   --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
//   --card-bg: rgba(255, 255, 255, 0.96);
//   --text-main: #0f172a;
//   --text-soft: #64748b;
//   --border: rgba(148, 163, 184, 0.18);
//   --shadow-lg: 0 22px 55px rgba(15, 23, 42, 0.08);

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) =>
//     collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease;

//   @media (max-width: 1024px) {
//     margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")};
//   }

//   @media (max-width: 768px) {
//     margin-left: 0;
//   }
// `;

// const Main = styled.main`
//   width: min(1450px, calc(100% - 32px));
//   margin: 0 auto;
//   padding: 90px 24px 60px; 

//   @media (max-width: 1024px) {
//     width: min(100%, calc(100% - 24px));
//     padding: 84px 20px 40px;
//   }

//   @media (max-width: 576px) {
//     width: min(100%, calc(100% - 16px));
//     padding: 80px 16px 28px;
//   }
// `;

// /* ================= HERO & EXPORT ================= */
// const HeroSection = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 24px;
//   margin-bottom: 24px;

//   @media (max-width: 900px) {
//     flex-direction: column;
//     align-items: stretch;
//   }
// `;

// const HeroPanel = styled.div`
//   flex: 1;
//   background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
//   color: white;
//   padding: 28px;
//   border-radius: 28px;
//   box-shadow: var(--shadow-lg);
//   position: relative;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   height: 183px;
//   &::before {
//     content: "";
//     position: absolute;
//     right: -30px;
//     bottom: -60px;
//     width: 180px;
//     height: 170px;
//     border-radius: 50%;
//     background: rgba(255, 255, 255, 0.08);
//   }
// `;

// const HeroTitle = styled.h1`
//   margin: 0;
//   font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem);
//   line-height: 1.1;
//   font-weight: 800;
//   margin-bottom: 75px;
//   position: relative;
//   z-index: 1;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.9);
//   line-height: 1.65;
//   font-size: 1.05rem;
//   position: absolute;
//   margin-top: 25px;
//   z-index: 1;
// `;

// const ExportWrap = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 12px;
//   min-width: 280px;

//   @media (max-width: 900px) {
//     display: flex;
//     flex-wrap: wrap;
//   }
// `;

// const ExportButton = styled.button`
//   appearance: none;
//   border: none;
//   outline: none;
//   border-radius: 12px;
//   padding: 14px 16px;
//   background: ${({ variant }) =>
//     variant === "primary"
//       ? "linear-gradient(135deg, #1d4ed8, #3b82f6)"
//       : "white"};
//   color: ${({ variant, disabled }) => (disabled ? "#94a3b8" : variant === "primary" ? "white" : "#0f172a")};
//   border: ${({ variant, disabled }) => (disabled ? "1px solid #e2e8f0" : variant === "primary" ? "none" : "1px solid #cbd5e1")};
//   box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 4px 12px rgba(37, 99, 235, 0.2)" : "0 2px 4px rgba(15, 23, 42, 0.05)")};
//   font-size: 14px;
//   font-weight: 800;
//   cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
//   transition: transform 0.2s ease, box-shadow 0.2s ease;
//   text-align: center;

//   &:hover {
//     transform: ${({ disabled }) => (disabled ? "none" : "translateY(-2px)")};
//     box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 6px 16px rgba(37, 99, 235, 0.3)" : "0 4px 8px rgba(15, 23, 42, 0.1)")};
//   }

//   @media (max-width: 900px) {
//     flex: 1;
//     min-width: 120px;
//   }
// `;

// /* ================= ACCORDION LIST STYLES ================= */
// const RecordList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
// `;

// const RecordItem = styled.div`
//   background: white;
//   border-radius: 20px;
//   border: 1px solid ${({ $expanded }) => ($expanded ? "#bfdbfe" : "#e2e8f0")};
//   box-shadow: ${({ $expanded }) => ($expanded ? "0 12px 30px rgba(37, 99, 235, 0.08)" : "0 4px 12px rgba(15, 23, 42, 0.03)")};
//   overflow: hidden;
//   transition: all 0.3s ease;
// `;

// const RecordHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 20px 24px;
//   background: ${({ $expanded }) => ($expanded ? "#eff6ff" : "white")};
//   cursor: pointer;
//   transition: background 0.2s ease;

//   &:hover {
//     background: #f8fafc;
//   }

//   @media (max-width: 576px) {
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 16px;
//     padding: 16px;
//   }
// `;

// const RecordHeaderInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
// `;
// //ETHIC
// const RecordHeaderTitle = styled.h3`
//   margin: 0;
//   font-size: 1.15rem;
//   font-weight: 800;
//   color: #0f172a;
// `;

// const RecordHeaderSub = styled.p`
//   margin: 0;
//   font-size: 0.9rem;
//   color: #64748b;
//   font-weight: 600;
// `;

// const ViewButton = styled.button`
//   appearance: none;
//   background: ${({ $expanded }) => ($expanded ? "#e2e8f0" : "linear-gradient(135deg, #1d4ed8, #3b82f6)")};
//   color: ${({ $expanded }) => ($expanded ? "#475569" : "white")};
//   border: none;
//   padding: 10px 24px;
//   border-radius: 12px;
//   font-weight: 800;
//   font-size: 0.95rem;
//   cursor: pointer;
//   transition: transform 0.2s ease;

//   &:hover {
//     transform: translateY(-2px);
//   }

//   @media (max-width: 576px) {
//     width: 100%;
//   }
// `;

// const DocumentWrapper = styled.div`
//   padding: 28px;
//   border-top: 1px solid #e2e8f0;
//   background: white;

//   @media (max-width: 576px) {
//     padding: 16px;
//   }
// `;

// /* ================= DOCUMENT INNER STYLES ================= */
// const DocumentTop = styled.div`
//   border-bottom: 2px solid #e2e8f0;
//   padding-bottom: 18px;
//   margin-bottom: 22px;
// `;

// const DocTitle = styled.h2`
//   font-size: clamp(1.3rem, 1.1rem + 0.6vw, 1.7rem);
//   font-weight: 800;
//   color: #0f172a;
//   margin: 0 0 10px;
// `;

// const PeriodRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 12px;
// `;

// const Pill = styled.div`
//   display: inline-flex;
//   align-items: center;
//   padding: 8px 12px;
//   background: ${(props) => props.bg || "#eff6ff"}; 
//   color: ${(props) => props.color || "#1d4ed8"}; 
//   border-radius: 999px;
//   font-size: 13px;
//   font-weight: 700;
// `;

// const SectionBlock = styled.section`
//   margin-top: 28px;
// `;

// const SectionHeading = styled.div`
//   background: ${({ variant }) => getThemeColors(variant).heading};
//   color: white;
//   border-radius: 16px;
//   padding: 14px 18px;
//   margin-bottom: 16px;
// `;

// const SectionTitle = styled.h3`
//   font-size: 18px;
//   font-weight: 800;
//   margin: 0 0 4px;
// `;

// const SectionSub = styled.p`
//   font-size: 13px;
//   margin: 0;
//   opacity: 0.9;
// `;

// const NoticeBox = styled.div`
//   border: 1px solid #dbeafe;
//   background: #f8fbff;
//   color: #334155;
//   border-radius: 14px;
//   padding: 16px;
//   margin-bottom: 18px;
//   line-height: 1.6;
//   font-size: 14px;
// `;

// const ScaleGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
//   gap: 10px;
//   margin-bottom: 18px;
// `;

// const ScaleItem = styled.div`
//   border: 1px solid #e5e7eb;
//   border-radius: 12px;
//   padding: 12px;
//   background: #fafafa;
// `;

// const ScaleScore = styled.div`
//   font-size: 22px;
//   font-weight: 800;
//   color: #0f172a;
// `;

// const ScaleText = styled.div`
//   font-size: 13px;
//   color: #475569;
// `;

// /* ================= COMPACT TABLE STYLES ================= */
// const TableWrap = styled.div`
//   overflow-x: hidden; 
//   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
//   border-radius: 16px;
//   margin-bottom: 18px;
//   width: 100%;

//   @media (max-width: 900px) {
//     display: none;
//   }
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   table-layout: fixed; 

//   th, td {
//     border-bottom: 1px solid #e5e7eb;
//     vertical-align: top;
//     padding: 8px 6px; 
//     font-size: 12px; 
//     word-wrap: break-word;
//     overflow-wrap: break-word;
//   }
// `;

// const ThemedTh = styled.th`
//   background: ${({ variant }) => getThemeColors(variant).thBg};
//   color: ${({ variant }) => getThemeColors(variant).thText};
//   font-weight: 800;
//   border-bottom: 2px solid ${({ variant }) => getThemeColors(variant).border};
//   border-right: 1px solid ${({ variant }) => getThemeColors(variant).border};
//   padding: 10px 6px;
//   text-align: left;
//   font-size: 11px;
//   text-transform: uppercase;
//   line-height: 1.3;
//   &:last-child { border-right: none; }
// `;

// const WeeklyRow = styled.tr`
//   background: #fef2f2; 
//   td { font-size: 11px; color: #334155; }
// `;

// const ThemedTotalsRow = styled.tr`
//   background: ${({ variant }) => getThemeColors(variant).rowBg};
//   td { font-weight: 800; color: ${({ variant }) => getThemeColors(variant).thText}; font-size: 12px; }
// `;

// const DisabledInput = styled.div`
//   min-height: 32px;
//   border: 1px solid #e2e8f0;
//   background: #f8fafc;
//   color: #334155;
//   border-radius: 6px;
//   padding: 6px 8px;
//   line-height: 1.4;
//   white-space: pre-wrap;
//   font-size: 12px;
//   resize: vertical;
//   overflow: auto;
// `;

// const SmallScore = styled.div`
//   width: 32px;
//   height: 32px;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 6px;
//   border: 1px solid #dbe3ee; 
//   background: ${(props) => (props.muted ? "#f8fafc" : "#eef2ff")}; 
//   font-weight: 800;
//   color: #0f172a;
//   font-size: 12px;
// `;

// /* ================= MOBILE/TABLET CARDS ================= */
// const CardGrid = styled.div`
//   display: none;

//   @media (max-width: 900px) {
//     display: grid;
//     gap: 16px;
//     margin-bottom: 18px;
//   }
// `;

// const RecordCard = styled.div`
//   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
//   border-left: 5px solid ${({ variant }) => getThemeColors(variant).pillText};
//   background: ${({ variant }) => getThemeColors(variant).thBg};
//   border-radius: 18px;
//   padding: 16px;
//   box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
// `;

// const RecordCardHead = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 10px;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   margin-bottom: 14px;
// `;

// const RecordIndex = styled.div`
//   width: 34px;
//   height: 34px;
//   border-radius: 50%;
//   background: ${({ variant }) => getThemeColors(variant).pillBg};
//   color: ${({ variant }) => getThemeColors(variant).pillText};
//   display: grid;
//   place-items: center;
//   font-weight: 800;
// `;

// const RecordLabel = styled.div`
//   font-size: 12px;
//   font-weight: 800;
//   text-transform: uppercase;
//   letter-spacing: 0.04em;
//   color: ${({ variant }) => getThemeColors(variant).pillText};
// `;

// const RecordFields = styled.div`
//   display: grid;
//   gap: 12px;
// `;

// const FieldBlock = styled.div``;

// const FieldTitle = styled.div`
//   font-size: 12px;
//   font-weight: 800;
//   color: #64748b;
//   text-transform: uppercase;
//   letter-spacing: 0.04em;
//   margin-bottom: 6px;
// `;

// const CompactScoreGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 10px;
//   @media (max-width: 420px) { grid-template-columns: 1fr; }
// `;

// const WeeklyCard = styled.div`
//   margin-top: 10px;
//   padding: 12px;
//   background: #fef2f2;
//   border-left: 4px solid #ef4444; 
//   border-radius: 12px;
// `;

// /* ================= SUMMARY ================= */
// const SummaryGrid = styled.div`
//   display: grid;
//   grid-template-columns: 1.2fr 1fr;
//   gap: 18px;

//   @media (max-width: 980px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const SummaryCard = styled.div`
//   border: 1px solid #e5e7eb;
//   border-radius: 16px;
//   padding: 24px;
//   background: white;
//   display: flex;
//   flex-direction: column;
// `;

// const SummaryCardTitle = styled.h4`
//   margin: 0 0 16px;
//   font-size: 1.1rem;
//   font-weight: 800;
//   color: #0f172a;
// `;

// const ScoreList = styled.div`
//   display: grid;
//   gap: 12px;
// `;

// const ScoreRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   padding: 14px 18px;
//   border-radius: 12px;
//   background: ${({ variant }) => getThemeColors(variant).thBg};
//   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
// `;

// const ScoreLabel = styled.div`
//   font-size: 14px;
//   font-weight: 700;
//   color: ${({ variant }) => getThemeColors(variant).thText};
// `;

// const ScoreValueBox = styled.div`
//   font-size: 1.1rem;
//   font-weight: 900;
//   color: ${({ variant }) => getThemeColors(variant).thText};
// `;

// const BigGrade = styled.div`
//   font-size: clamp(2rem, 1.8rem + 1vw, 2.6rem);
//   font-weight: 900;
//   color: #1d4ed8; 
// `;

// const TextBlock = styled.div`
//   flex: 1;
//   min-height: 110px;
//   border: 1px solid #e2e8f0;
//   border-radius: 14px;
//   background: #f8fafc;
//   padding: 16px;
//   white-space: pre-wrap;
//   line-height: 1.7;
//   color: #334155;
//   resize: vertical;
//   overflow: auto;
// `;

// const GradeTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   border-radius: 12px;
//   overflow: hidden;
//   border: 1px solid #bfdbfe; 
//   font-size: 0.9rem;
//   background: white;
//   margin-top: auto;

//   th {
//     background: linear-gradient(135deg, #1e3a8a, #2563eb); 
//     color: white;
//     font-weight: 800;
//     padding: 14px;
//     text-align: left;
//     border-bottom: 2px solid #1e40af; 
//   }
//   td {
//     padding: 12px 14px;
//     border-bottom: 1px solid #dbeafe; 
//     color: #1e3a8a; 
//     font-weight: 700;
//   }
//   tr:last-child td { border-bottom: none; }
// `;

// /* ================= LOADING / EMPTY STATES ================= */
// const CenterState = styled.div`
//   min-height: 60vh;
//   display: grid;
//   place-items: center;
//   padding: 24px;
// `;

// const StateCard = styled.div`
//   width: min(460px, 100%);
//   background: rgba(255, 255, 255, 0.95);
//   border: 1px solid var(--border);
//   border-radius: 24px;
//   padding: 28px;
//   text-align: center;
//   box-shadow: var(--shadow-md);
// `;

// const Spinner = styled.div`
//   width: 46px;
//   height: 46px;
//   margin: 0 auto 18px;
//   border-radius: 50%;
//   border: 4px solid #dbeafe;
//   border-top-color: #2563eb;
//   animation: spin 0.8s linear infinite;

//   @keyframes spin {
//     to { transform: rotate(360deg); }
//   }
// `;

// const StateTitle = styled.h3`
//   margin: 0;
//   font-size: 1.1rem;
//   color: #0f172a;
// `;

// const StateText = styled.p`
//   margin: 10px 0 0;
//   color: var(--text-soft);
//   line-height: 1.6;
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 90px 20px;
//   color: #64748b;
//   background: white;
//   border-radius: 20px;
//   border: 1px dashed #cbd5e1;
// `;

// /* ================= COMPONENT ================= */
// const Records = ({ user, collapsed, setCollapsed }) => {
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [expandedId, setExpandedId] = useState("");

//   useEffect(() => {
//     const fetchRecords = async () => {
//       try {
//         const res = await api.get("/appraisal/all");
//         setRecords(res.data?.data || []);
//       } catch (err) {
//         console.error("Failed to fetch records", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRecords();
//   }, []);

//   const allTabs = useMemo(() => {
//     const tabs = [];
//     records.forEach((record) => {
//       const yearMatch = record.appraisalPeriod.match(/\d{4}/);
//       const year = yearMatch ? yearMatch[0] : ""; 
//       (record.section2 || []).forEach((m) => {
//         const monthName = m.month || "Unknown";
//         const displayYear = (year && !monthName.includes(year)) ? ` ${year}` : "";
//         tabs.push({
//           id: `${record.appraisalPeriod}-${monthName}`,
//           period: record.appraisalPeriod,
//           month: monthName,
//           label: `Performance Record for ${monthName}${displayYear}`,
//           record: record, 
//           monthData: m    
//         });
//       });
//     });
//     return tabs;
//   }, [records]);

//   const currentTab = useMemo(() => {
//     return allTabs.find(tab => tab.id === expandedId) || null;
//   }, [allTabs, expandedId]);

//   const exportData = useMemo(() => {
//     if (!currentTab) return null;
//     return {
//       appraisalPeriod: currentTab.record.appraisalPeriod,
//       selectedMonth: currentTab.month,
//       section2: currentTab.monthData || null,
//       section3: currentTab.record.section3 || [],
//       section4: currentTab.record.section4 || [],
//       summary: currentTab.record.summary || {},
//       staffFeedback: currentTab.record.staffFeedback || {},
//     };
//   }, [currentTab]);

//   const exportBaseName = `performance-record-${currentTab?.period || "record"}-${currentTab?.month || "month"}`;

//   const handleExportJSON = () => {
//     if (!exportData) return;
//     downloadBlob(JSON.stringify(exportData, null, 2), `${exportBaseName}.json`, "application/json");
//   };

//   const handleExportTXT = () => {
//     if (!exportData) return;
//     const txt = `
// PERFORMANCE RECORD
// Period: ${currentTab.period}
// Month: ${currentTab.month}

// SUMMARY
// Section 2: ${formatValue(exportData.summary?.section2, 0)}
// Section 3: ${formatValue(exportData.summary?.section3, 0)}
// Section 4: ${formatValue(exportData.summary?.section4, 0)}
// Cumulative: ${formatValue(exportData.summary?.cumulative, 0)}
// Grade: ${formatValue(exportData.summary?.grade, "—")}
// Supervisor's Grade: ${formatValue(exportData.summary?.supervisorGrade, "—")}

// CITATION
// ${formatValue(exportData.summary?.citation)}

// SUPERVISOR OVERALL COMMENTS
// ${formatValue(exportData.staffFeedback?.supervisorAttention)}
// `.trim();
//     downloadBlob(txt, `${exportBaseName}.txt`, "text/plain;charset=utf-8");
//   };

//   const handleExportCSV = () => {
//     if (!exportData) return;
//     const rows = [];
//     rows.push(["section", "group", "title", "achievement", "staffActionScore", "staffQualityScore", "supervisorActionScore", "supervisorQualityScore", "staffScore", "supervisorScore", "comments"].map(toCSVValue).join(","));
//     downloadBlob(rows.join("\n"), `${exportBaseName}.csv`, "text/csv;charset=utf-8");
//   };

//   const handlePrintPDF = () => window.print();

//   if (loading) {
//     return (
//       <Container collapsed={collapsed}>
//         <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//         <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
//         <CenterState><StateCard><Spinner /><StateTitle>Loading records</StateTitle></StateCard></CenterState>
//       </Container>
//     );
//   }
  // if (!records.length || allTabs.length === 0) {
  //   return (
  //     <Container collapsed={collapsed}>
  //       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
  //       <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
  //       <Main>
  //         <EmptyState>No records found yet.</EmptyState>
  //       </Main>
  //     </Container>
  //   );
  // }

//   return (
//     <Container collapsed={collapsed}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
//       <Main>
//         <HeroSection>
//           <HeroPanel>
//             <HeroTitle>Records</HeroTitle>
//             <HeroText>View your performance records fully displayed per period.</HeroText>
//           </HeroPanel>
//           <ExportWrap>
//             <ExportButton variant="primary" disabled={!expandedId} onClick={handlePrintPDF}>Print / PDF</ExportButton>
//             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportCSV}>Export CSV</ExportButton>
//             {/* <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportJSON}>Export JSON</ExportButton> */}
//             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportTXT}>Export Word</ExportButton>
//           </ExportWrap>
//         </HeroSection>

//         <RecordList>
//           {allTabs.map((tab) => {
//             const isExpanded = expandedId === tab.id;
//             const recordData = tab.record;
//             const monthData = tab.monthData;

//             return (
//               <RecordItem key={tab.id} $expanded={isExpanded}>
//                 <RecordHeader $expanded={isExpanded} onClick={() => setExpandedId(isExpanded ? "" : tab.id)}>
//                   <RecordHeaderInfo>
//                     <RecordHeaderTitle>{tab.label}</RecordHeaderTitle>
//                     <RecordHeaderSub>Period: {tab.period}</RecordHeaderSub>
//                   </RecordHeaderInfo>
//                   <ViewButton $expanded={isExpanded}>{isExpanded ? "Close" : "View"}</ViewButton>
//                 </RecordHeader>

//                 {isExpanded && (
//                   <DocumentWrapper>
//                     <DocumentTop>
//                       <DocTitle>Quarterly Performance Form</DocTitle>
//                       <PeriodRow>
//                         <Pill>{tab.period}</Pill>
//                         <Pill bg="#ecfeff" color="#0f766e">Month: {tab.month}</Pill>
//                       </PeriodRow>
//                     </DocumentTop>

//                     {/* SECTION 2 */}
//                     <SectionBlock>
//                       <SectionHeading variant="red">
//                         <SectionTitle>PERFORMANCE ON GOALS</SectionTitle>
//                       </SectionHeading>
// {/* //55 */}
//                       <SectionTitle style={{ marginBottom: 12, fontSize: '14px' }}>Major Goals - 55 Marks</SectionTitle>
//                       <TableWrap variant="red">
//                         <Table>
//                           <colgroup>
//                             <col style={{ width: "35px" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "110px" }} />
//                             <col style={{ width: "115px" }} />
//                             <col style={{ width: "150px" }} />
//                           </colgroup>
//                           <thead>
//                             <tr>
//                               <ThemedTh variant="red">S/N</ThemedTh>
//                               <ThemedTh variant="red">MAJOR GOALS</ThemedTh>
//                               <ThemedTh variant="red">ACHIEVEMENTS</ThemedTh>
//                               <ThemedTh variant="red">YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
//                               <ThemedTh variant="red">YOUR SCORE ON QUALITY (0-5)</ThemedTh>
//                               <ThemedTh variant="red">SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
//                               <ThemedTh variant="red">SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
//                               <ThemedTh variant="red">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(monthData?.majorGoals || []).map((goal, index) => (
//                               <React.Fragment key={index}>
//                                 <tr>
//                                   <td>{index + 1}</td>
//                                   <td><DisabledInput>{formatValue(goal.goal)}</DisabledInput></td>
//                                   <td><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></td>
//                                   <td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></td>
//                                   <td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
//                                   <td><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
//                                   <td><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
//                                   <td><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></td>
//                                 </tr>
//                                 {(goal.weekly || []).map((week, weekIndex) => (
//                                   <WeeklyRow key={`${index}-${weekIndex}`}>
//                                     <td></td>
//                                     <td>
//                                       <strong>{formatValue(week.week, `Week ${weekIndex + 1}`)}</strong>
//                                       <div style={{ marginTop: 8 }}>{formatValue(week.weeklyGoal)}</div>
//                                     </td>
//                                     <td>{formatValue(week.weeklyAchievement)}</td>
//                                     <td colSpan="5" style={{ opacity: 0.6, fontSize: '10px' }}>NO SCORES FOR WEEKLY GOALS</td>
//                                   </WeeklyRow>
//                                 ))}
//                               </React.Fragment>
//                             ))}
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{formatValue(monthData?.majorSumA, 0)}</td>
//                               <td>{formatValue(monthData?.majorSumQ, 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">SCORE (SS/GOALS)</td>
//                               <td>{formatValue(monthData?.majorGoals?.length ? (safeNumber(monthData?.majorSumA) / monthData.majorGoals.length).toFixed(2) : 0)}</td>
//                               <td>{formatValue(monthData?.majorGoals?.length ? (safeNumber(monthData?.majorSumQ) / monthData.majorGoals.length).toFixed(2) : 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
//                               <td colSpan="2">{formatValue(monthData?.majorCombined, 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">TOTAL SCORE (CS/5 × 55 Marks)</td>
//                               <td colSpan="5">{formatValue(monthData?.majorTotalMarks, 0)} / 55</td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>
//                 {/* //60 */}
//                       {/* MOBILE VIEW CARDS FOR MAJOR GOALS */}
//                       <CardGrid>
//                         {(monthData?.majorGoals || []).map((goal, index) => (
//                           <RecordCard variant="red" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="red">{index + 1}</RecordIndex>
//                               <RecordLabel variant="red">Major Goal</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
//                               {(goal.weekly || []).map((week, weekIndex) => (
//                                 <WeeklyCard key={weekIndex}>
//                                   <FieldTitle>{formatValue(week.week, `Week ${weekIndex + 1}`)}</FieldTitle>
//                                   <div>{formatValue(week.weeklyGoal)}</div>
//                                   <div style={{ marginTop: 8, color: "#64748b" }}>{formatValue(week.weeklyAchievement)}</div>
//                                 </WeeklyCard>
//                               ))}
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>

//                       <SectionTitle style={{ marginBottom: 12, fontSize: '14px' }}>Other Goals - 15 Marks</SectionTitle>
//                       <TableWrap variant="orange">
//                         <Table>
//                           <colgroup>
//                             <col style={{ width: "35px" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "110px" }} />
//                             <col style={{ width: "115px" }} />
//                             <col style={{ width: "150px" }} />
//                           </colgroup>
//                           <thead>
//                                                         <tr>
//                               <ThemedTh variant="orange">S/N</ThemedTh>
//                               <ThemedTh variant="orange">MAJOR GOALS</ThemedTh>
//                               <ThemedTh variant="orange">ACHIEVEMENTS</ThemedTh>
//                               <ThemedTh variant="orange">YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">YOUR SCORE ON QUALITY (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(monthData?.otherGoals || []).map((goal, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td><DisabledInput>{formatValue(goal.goal)}</DisabledInput></td>
//                                 <td><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></td>
//                                 <td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></td>
//                                 <td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
//                                 <td><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
//                                 <td><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
//                                 <td><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></td>
//                               </tr>
//                             ))}
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{formatValue(monthData?.otherSumA, 0)}</td>
//                               <td>{formatValue(monthData?.otherSumQ, 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">SCORE (SS/GOALS)</td>
//                               <td>{formatValue(monthData?.otherGoals?.length ? (safeNumber(monthData?.otherSumA) / monthData.otherGoals.length).toFixed(2) : 0)}</td>
//                               <td>{formatValue(monthData?.otherGoals?.length ? (safeNumber(monthData?.otherSumQ) / monthData.otherGoals.length).toFixed(2) : 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
//                               <td colSpan="2">{formatValue(monthData?.otherCombined, 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">TOTAL SCORE (CS/5 × 15 Marks)</td>
//                               <td colSpan="5">{formatValue(monthData?.otherTotalMarks, 0)} / 15</td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR OTHER GOALS */}
//                       <CardGrid>
//                         {(monthData?.otherGoals || []).map((goal, index) => (
//                           <RecordCard variant="orange" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="orange">{index + 1}</RecordIndex>
//                               <RecordLabel variant="orange">Other Goal</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>
//                     </SectionBlock>

//                     {/* SECTION 3 */}
//                     <SectionBlock>
//                       <SectionHeading variant="purple">
//                         <SectionTitle>WORK ETHIC & LEADERSHIP</SectionTitle>
//                       </SectionHeading>
//                       <TableWrap variant="purple">
//                         <Table>
//                           <colgroup>
//                             <col style={{ width: "35px" }} />
//                             <col style={{ width: "130px" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "120px" }} />
//                             <col style={{ width: "115px" }} />
//                             <col style={{ width: "150px" }} />
//                           </colgroup>
//                           <thead>
//                                                                                   <tr>
//                               <ThemedTh variant="purple">S/N</ThemedTh>
//                               <ThemedTh variant="purple">MAJOR GOALS</ThemedTh>
//                               <ThemedTh variant="purple">ACHIEVEMENTS</ThemedTh>
//                               <ThemedTh variant="purple">YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
//                               <ThemedTh variant="purple">YOUR SCORE ON QUALITY (0-5)</ThemedTh>
//                               <ThemedTh variant="purple">SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
//                               <ThemedTh variant="purple">SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
//                               <ThemedTh variant="purple">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(recordData?.section3 || []).map((item, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
//                                 <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
//                                 <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
//                                 <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
//                                 <td><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></td>
//                                 <td><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></td>
//                               </tr>
//                             ))}
//                             <ThemedTotalsRow variant="purple">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{(recordData?.section3 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="purple">
//                               <td colSpan="3">SCORE (SS/10)</td>
//                               <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="purple">
//                               <td colSpan="3">TOTAL SCORE (SCORE/5 × 15 Marks)</td>
//                               <td colSpan="4">{formatValue(recordData?.summary?.section3, 0)} / 15</td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR WORK ETHIC */}
//                       <CardGrid>
//                         {(recordData?.section3 || []).map((item, index) => (
//                           <RecordCard variant="purple" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="purple">{index + 1}</RecordIndex>
//                               <RecordLabel variant="purple">Work Ethic</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Attribute</FieldTitle><DisabledInput>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput>{formatValue(item.description)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>
//                     </SectionBlock>

//                     {/* SECTION 4 */}
//                     <SectionBlock>
//                       <SectionHeading variant="green">
//                         <SectionTitle>COMPLIANCE</SectionTitle>
//                       </SectionHeading>
//                       <TableWrap variant="green">
//                         <Table>
//                           <colgroup>
//                             <col style={{ width: "35px" }} />
//                             <col style={{ width: "130px" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "120px" }} />
//                             <col style={{ width: "115px" }} />
//                             <col style={{ width: "150px" }} />
//                           </colgroup>
//                           <thead>
//                                                                                                             <tr>
//                               <ThemedTh variant="green">S/N</ThemedTh>
//                               <ThemedTh variant="green">MAJOR GOALS</ThemedTh>
//                               <ThemedTh variant="green">ACHIEVEMENTS</ThemedTh>
//                               <ThemedTh variant="green">YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
//                               <ThemedTh variant="green">YOUR SCORE ON QUALITY (0-5)</ThemedTh>
//                               <ThemedTh variant="green">SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
//                               <ThemedTh variant="green">SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
//                               <ThemedTh variant="green">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(recordData?.section4 || []).map((item, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
//                                 <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
//                                 <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
//                                 <td><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></td>
//                                 <td><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></td>
//                                 <td><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></td>
//                               </tr>
//                             ))}
//                             <ThemedTotalsRow variant="green">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{(recordData?.section4 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="green">
//                               <td colSpan="3">SCORE (SS/13)</td>
//                               <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td colSpan="3"></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="green">
//                               <td colSpan="3">TOTAL SCORE (SCORE/5 × 10 Marks)</td>
//                               <td colSpan="4">{formatValue(recordData?.summary?.section4, 0)} / 10</td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR COMPLIANCE */}
//                       <CardGrid>
//                         {(recordData?.section4 || []).map((item, index) => (
//                           <RecordCard variant="green" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="green">{index + 1}</RecordIndex>
//                               <RecordLabel variant="green">Compliance</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Protocol</FieldTitle><DisabledInput>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput>{formatValue(item.description)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>
//                     </SectionBlock>

//                     <SectionBlock>
//                       <SectionHeading variant="blue"><SectionTitle>SUMMARY</SectionTitle></SectionHeading>
//                       <SummaryGrid>
//                         <SummaryCard>
//                           <SummaryCardTitle>Citations of Your Achievements</SummaryCardTitle>
//                           <TextBlock>{formatValue(recordData?.summary?.citation)}</TextBlock>
                          
//                           <SummaryCardTitle style={{ marginTop: '24px' }}>Grading Scale</SummaryCardTitle>
//                           <GradeTable>
//                             <thead><tr><th>SCORE RANGE</th><th>GRADE</th></tr></thead>
//                             <tbody>
//                               <tr><td>80% - Above</td><td>A</td></tr>
//                               <tr><td>70% - 79%</td><td>B</td></tr>
//                               <tr><td>60% - 69%</td><td>C</td></tr>
//                               <tr><td>50% - 59%</td><td>D</td></tr>
//                               <tr><td>49% - Below</td><td>E</td></tr>
//                             </tbody>
//                           </GradeTable>
//                         </SummaryCard>
                        
//                         <SummaryCard>
//                           <SummaryCardTitle>Total Scores</SummaryCardTitle>
//                           <ScoreList>
//                             <ScoreRow variant="red">
//                               <ScoreLabel variant="red">Goals</ScoreLabel>
//                               <ScoreValueBox variant="red">{formatValue(recordData?.summary?.section2, 0)}</ScoreValueBox>
//                             </ScoreRow>
//                             <ScoreRow variant="purple">
//                               <ScoreLabel variant="purple">Ethics</ScoreLabel>
//                               <ScoreValueBox variant="purple">{formatValue(recordData?.summary?.section3, 0)}</ScoreValueBox>
//                             </ScoreRow>
//                             <ScoreRow variant="green">
//                               <ScoreLabel variant="green">Compliance</ScoreLabel>
//                               <ScoreValueBox variant="green">{formatValue(recordData?.summary?.section4, 0)}</ScoreValueBox>
//                             </ScoreRow>
//                             <ScoreRow variant="dark">
//                               <ScoreLabel variant="dark">Performance Score for the Month</ScoreLabel>
//                               <ScoreValueBox variant="dark">{formatValue(recordData?.summary?.cumulative, 0)}</ScoreValueBox>
//                             </ScoreRow>
//                             <ScoreRow variant="dark">
//                               <ScoreLabel variant="dark">Supervisor Cumulative</ScoreLabel>
//                               <ScoreValueBox variant="dark">{formatValue(recordData?.summary?.supervisorCumulative, "—")}</ScoreValueBox>
//                             </ScoreRow>
//                           </ScoreList>
                          
//                           <div style={{ marginTop: 18, display: "flex", justifyContent: "space-between", gap: 18 }}>
//                             <div>
//                               <div style={{ fontSize: 13, color: "#64748b" }}>Grade</div>
//                               <BigGrade>{formatValue(recordData?.summary?.grade, "—")}</BigGrade>
//                             </div>
//                             <div>
//                               <div style={{ fontSize: 13, color: "#64748b" }}>Supervisor Grade</div>
//                               <BigGrade style={{ color: "#0f766e" }}>{formatValue(recordData?.summary?.supervisorGrade, "—")}</BigGrade>
//                             </div>
//                           </div>
//                         </SummaryCard>
//                       </SummaryGrid>
//                     </SectionBlock>

//                     <SectionBlock>
//                       <SectionHeading variant="blue">
//                         <SectionTitle>SUPERVISOR’S OVERALL COMMENTS</SectionTitle>
//                       </SectionHeading>
//                       <TextBlock>{formatValue(recordData?.staffFeedback?.supervisorAttention)}</TextBlock>
//                     </SectionBlock>

//                   </DocumentWrapper>
//                 )}
//               </RecordItem>
//             );
//           })}
//         </RecordList>
//          <Footer />
//       </Main>
//     </Container>
//   );
// };

// export default Records;
//calc
// //appraisal/all




// import React, { useEffect, useMemo, useState } from "react";
// import styled from "styled-components";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import api from "../api";
// import Footer from "./Footer";

// /* ================= HELPERS ================= */
// const formatValue = (value, fallback = "—") => {
//   if (value === null || value === undefined || value === "") return fallback;
//   return value;
// };

// const scoreValue = (value) => {
//   if (value === null || value === undefined || value === "") return "—";
//   return value;
// };

// const safeNumber = (value) => {
//   const num = Number(value);
//   return Number.isNaN(num) ? 0 : num;
// };

// const downloadBlob = (content, filename, type) => {
//   const blob = new Blob([content], { type });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = filename;
//   link.click();
//   URL.revokeObjectURL(url);
// };

// const toCSVValue = (value) => {
//   const stringValue = String(value ?? "");
//   return `"${stringValue.replace(/"/g, '""')}"`;
// };

// /* ================= THEME UTILITY ================= */
// const getThemeColors = (variant) => {
//   switch (variant) {
//     case "orange":
//       return { 
//         thBg: "#fff7ed", thText: "#9a3412", border: "#fed7aa", rowBg: "#ffedd5", 
//         heading: "linear-gradient(135deg, #7c2d12, #ea580c)", pillBg: "#ffedd5", pillText: "#ea580c" 
//       };
//     case "purple":
//       return { 
//         thBg: "#f5f3ff", thText: "#5b21b6", border: "#ddd6fe", rowBg: "#ede9fe", 
//         heading: "linear-gradient(135deg, #4c1d95, #8b5cf6)", pillBg: "#ede9fe", pillText: "#7c3aed" 
//       };
//     case "green":
//       return { 
//         thBg: "#f0fdf4", thText: "#15803d", border: "#bbf7d0", rowBg: "#dcfce7", 
//         heading: "linear-gradient(135deg, #14532d, #22c55e)", pillBg: "#dcfce7", pillText: "#16a34a" 
//       };
//     case "dark":
//       return {
//         thBg: "#f8fafc", thText: "#0f172a", border: "#e2e8f0", rowBg: "#f1f5f9",
//         heading: "linear-gradient(135deg, #0f172a, #334155)", pillBg: "#e2e8f0", pillText: "#0f172a"
//       };
//     case "red": 
//       return {
//         thBg: "#fef2f2", thText: "#991b1b", border: "#fca5a5", rowBg: "#fee2e2",
//         heading: "linear-gradient(135deg, #7f1d1d, #ef4444)", pillBg: "#fee2e2", pillText: "#dc2626"
//       };
//     default: // Blue
//       return { 
//         thBg: "#eff6ff", thText: "#1e40af", border: "#bfdbfe", rowBg: "#dbeafe", 
//         heading: "linear-gradient(135deg, #1e3a8a, #3b82f6)", pillBg: "#dbeafe", pillText: "#2563eb" 
//       };
//   }
// };

// /* ================= LAYOUT ================= */
// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
//   --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
//   --card-bg: rgba(255, 255, 255, 0.96);
//   --text-main: #0f172a;
//   --text-soft: #64748b;
//   --border: rgba(148, 163, 184, 0.18);
//   --shadow-lg: 0 22px 55px rgba(15, 23, 42, 0.08);

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) =>
//     collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease;

//   @media (max-width: 1024px) {
//     margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")};
//   }

//   @media (max-width: 768px) {
//     margin-left: 0;
//   }
// `;

// const Main = styled.main`
//   width: min(1450px, calc(100% - 32px));
//   margin: 0 auto;
//   padding: 90px 24px 60px; 

//   @media (max-width: 1024px) {
//     width: min(100%, calc(100% - 24px));
//     padding: 84px 20px 40px;
//   }

//   @media (max-width: 576px) {
//     width: min(100%, calc(100% - 16px));
//     padding: 80px 16px 28px;
//   }
// `;

// /* ================= HERO & EXPORT ================= */
// const HeroSection = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 24px;
//   margin-bottom: 24px;

//   @media (max-width: 900px) {
//     flex-direction: column;
//     align-items: stretch;
//   }
// `;

// const HeroPanel = styled.div`
//   flex: 1;
//   background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
//   color: white;
//   padding: 28px;
//   border-radius: 28px;
//   box-shadow: var(--shadow-lg);
//   position: relative;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   height: 183px;
//   &::before {
//     content: "";
//     position: absolute;
//     right: -30px;
//     bottom: -60px;
//     width: 180px;
//     height: 170px;
//     border-radius: 50%;
//     background: rgba(255, 255, 255, 0.08);
//   }
// `;

// const HeroTitle = styled.h1`
//   margin: 0;
//   font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem);
//   line-height: 1.1;
//   font-weight: 800;
//   margin-bottom: 75px;
//   position: relative;
//   z-index: 1;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.9);
//   line-height: 1.65;
//   font-size: 1.05rem;
//   position: absolute;
//   margin-top: 25px;
//   z-index: 1;
// `;

// const ExportWrap = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 12px;
//   min-width: 280px;

//   @media (max-width: 900px) {
//     display: flex;
//     flex-wrap: wrap;
//   }
// `;

// const ExportButton = styled.button`
//   appearance: none;
//   border: none;
//   outline: none;
//   border-radius: 12px;
//   padding: 14px 16px;
//   background: ${({ variant }) =>
//     variant === "primary"
//       ? "linear-gradient(135deg, #1d4ed8, #3b82f6)"
//       : "white"};
//   color: ${({ variant, disabled }) => (disabled ? "#94a3b8" : variant === "primary" ? "white" : "#0f172a")};
//   border: ${({ variant, disabled }) => (disabled ? "1px solid #e2e8f0" : variant === "primary" ? "none" : "1px solid #cbd5e1")};
//   box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 4px 12px rgba(37, 99, 235, 0.2)" : "0 2px 4px rgba(15, 23, 42, 0.05)")};
//   font-size: 14px;
//   font-weight: 800;
//   cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
//   transition: transform 0.2s ease, box-shadow 0.2s ease;
//   text-align: center;

//   &:hover {
//     transform: ${({ disabled }) => (disabled ? "none" : "translateY(-2px)")};
//     box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 6px 16px rgba(37, 99, 235, 0.3)" : "0 4px 8px rgba(15, 23, 42, 0.1)")};
//   }

//   @media (max-width: 900px) {
//     flex: 1;
//     min-width: 120px;
//   }
// `;

// /* ================= ACCORDION LIST STYLES ================= */
// const RecordList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
// `;

// const RecordItem = styled.div`
//   background: white;
//   border-radius: 20px;
//   border: 1px solid ${({ $expanded }) => ($expanded ? "#bfdbfe" : "#e2e8f0")};
//   box-shadow: ${({ $expanded }) => ($expanded ? "0 12px 30px rgba(37, 99, 235, 0.08)" : "0 4px 12px rgba(15, 23, 42, 0.03)")};
//   overflow: hidden;
//   transition: all 0.3s ease;
// `;

// const RecordHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 20px 24px;
//   background: ${({ $expanded }) => ($expanded ? "#eff6ff" : "white")};
//   cursor: pointer;
//   transition: background 0.2s ease;

//   &:hover {
//     background: #f8fafc;
//   }

//   @media (max-width: 576px) {
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 16px;
//     padding: 16px;
//   }
// `;

// const RecordHeaderInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
// `;
// //ETHIC
// const RecordHeaderTitle = styled.h3`
//   margin: 0;
//   font-size: 1.15rem;
//   font-weight: 800;
//   color: #0f172a;
// `;

// const RecordHeaderSub = styled.p`
//   margin: 0;
//   font-size: 0.9rem;
//   color: #64748b;
//   font-weight: 600;
// `;

// const ViewButton = styled.button`
//   appearance: none;
//   background: ${({ $expanded }) => ($expanded ? "#e2e8f0" : "linear-gradient(135deg, #1d4ed8, #3b82f6)")};
//   color: ${({ $expanded }) => ($expanded ? "#475569" : "white")};
//   border: none;
//   padding: 10px 24px;
//   border-radius: 12px;
//   font-weight: 800;
//   font-size: 0.95rem;
//   cursor: pointer;
//   transition: transform 0.2s ease;

//   &:hover {
//     transform: translateY(-2px);
//   }

//   @media (max-width: 576px) {
//     width: 100%;
//   }
// `;

// const DocumentWrapper = styled.div`
//   padding: 28px;
//   border-top: 1px solid #e2e8f0;
//   background: white;

//   @media (max-width: 576px) {
//     padding: 16px;
//   }
// `;

// /* ================= DOCUMENT INNER STYLES ================= */
// const DocumentTop = styled.div`
//   border-bottom: 2px solid #e2e8f0;
//   padding-bottom: 18px;
//   margin-bottom: 22px;
// `;

// const DocTitle = styled.h2`
//   font-size: clamp(1.3rem, 1.1rem + 0.6vw, 1.7rem);
//   font-weight: 800;
//   color: #0f172a;
//   margin: 0 0 10px;
// `;

// const PeriodRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 12px;
// `;

// const Pill = styled.div`
//   display: inline-flex;
//   align-items: center;
//   padding: 8px 12px;
//   background: ${(props) => props.bg || "#eff6ff"}; 
//   color: ${(props) => props.color || "#1d4ed8"}; 
//   border-radius: 999px;
//   font-size: 13px;
//   font-weight: 700;
// `;

// const SectionBlock = styled.section`
//   margin-top: 28px;
// `;

// const SectionHeading = styled.div`
//   background: ${({ variant }) => getThemeColors(variant).heading};
//   color: white;
//   border-radius: 16px;
//   padding: 14px 18px;
//   margin-bottom: 16px;
// `;

// const SectionTitle = styled.h3`
//   font-size: 18px;
//   font-weight: 800;
//   margin: 0 0 4px;
// `;

// const SectionSub = styled.p`
//   font-size: 13px;
//   margin: 0;
//   opacity: 0.9;
// `;

// const NoticeBox = styled.div`
//   border: 1px solid #dbeafe;
//   background: #f8fbff;
//   color: #334155;
//   border-radius: 14px;
//   padding: 16px;
//   margin-bottom: 18px;
//   line-height: 1.6;
//   font-size: 14px;
// `;

// const ScaleGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
//   gap: 10px;
//   margin-bottom: 18px;
// `;

// const ScaleItem = styled.div`
//   border: 1px solid #e5e7eb;
//   border-radius: 12px;
//   padding: 12px;
//   background: #fafafa;
// `;

// const ScaleScore = styled.div`
//   font-size: 22px;
//   font-weight: 800;
//   color: #0f172a;
// `;

// const ScaleText = styled.div`
//   font-size: 13px;
//   color: #475569;
// `;

// /* ================= COMPACT TABLE STYLES ================= */
// const TableWrap = styled.div`
//   overflow-x: hidden; 
//   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
//   border-radius: 16px;
//   margin-bottom: 18px;
//   width: 100%;

//   @media (max-width: 900px) {
//     display: none;
//   }
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   table-layout: fixed; 

//   th, td {
//     border-bottom: 1px solid #e5e7eb;
//     vertical-align: top;
//     padding: 8px 6px; 
//     font-size: 12px; 
//     word-wrap: break-word;
//     overflow-wrap: break-word;
//   }
// `;

// const ThemedTh = styled.th`
//   background: ${({ variant }) => getThemeColors(variant).thBg};
//   color: ${({ variant }) => getThemeColors(variant).thText};
//   font-weight: 800;
//   border-bottom: 2px solid ${({ variant }) => getThemeColors(variant).border};
//   border-right: 1px solid ${({ variant }) => getThemeColors(variant).border};
//   padding: 10px 6px;
//   text-align: left;
//   font-size: 11px;
//   text-transform: uppercase;
//   line-height: 1.3;
//   &:last-child { border-right: none; }
// `;

// const WeeklyRow = styled.tr`
//   background: #fef2f2; 
//   td { font-size: 11px; color: #334155; }
// `;

// const ThemedTotalsRow = styled.tr`
//   background: ${({ variant }) => getThemeColors(variant).rowBg};
//   td { font-weight: 800; color: ${({ variant }) => getThemeColors(variant).thText}; font-size: 12px; }
// `;
// const DisabledInput = styled.div`
//   min-height: 32px;
//   border: 1px solid #e2e8f0;
//   background: #f8fafc;
//   color: #334155;
//   border-radius: 6px;
//   padding: 6px 8px;
//   line-height: 1.4;
//   white-space: pre-wrap;
//   font-size: 12px;
//   /* Removed 'resize: vertical' so these boxes cannot be adjusted */
//   overflow: hidden; 
// `;

// const SmallScore = styled.div`
//   width: 32px;
//   height: 32px;
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 6px;
//   border: 1px solid #dbe3ee; 
//   background: ${(props) => (props.muted ? "#f8fafc" : "#eef2ff")}; 
//   font-weight: 800;
//   color: #0f172a;
//   font-size: 12px;
// `;

// /* ================= MOBILE/TABLET CARDS ================= */
// const CardGrid = styled.div`
//   display: none;

//   @media (max-width: 900px) {
//     display: grid;
//     gap: 16px;
//     margin-bottom: 18px;
//   }
// `;

// const RecordCard = styled.div`
//   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
//   border-left: 5px solid ${({ variant }) => getThemeColors(variant).pillText};
//   background: ${({ variant }) => getThemeColors(variant).thBg};
//   border-radius: 18px;
//   padding: 16px;
//   box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
// `;

// const RecordCardHead = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 10px;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   margin-bottom: 14px;
// `;

// const RecordIndex = styled.div`
//   width: 34px;
//   height: 34px;
//   border-radius: 50%;
//   background: ${({ variant }) => getThemeColors(variant).pillBg};
//   color: ${({ variant }) => getThemeColors(variant).pillText};
//   display: grid;
//   place-items: center;
//   font-weight: 800;
// `;

// const RecordLabel = styled.div`
//   font-size: 12px;
//   font-weight: 800;
//   text-transform: uppercase;
//   letter-spacing: 0.04em;
//   color: ${({ variant }) => getThemeColors(variant).pillText};
// `;

// const RecordFields = styled.div`
//   display: grid;
//   gap: 12px;
// `;

// const FieldBlock = styled.div``;

// const FieldTitle = styled.div`
//   font-size: 12px;
//   font-weight: 800;
//   color: #64748b;
//   text-transform: uppercase;
//   letter-spacing: 0.04em;
//   margin-bottom: 6px;
// `;

// const CompactScoreGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 10px;
//   @media (max-width: 420px) { grid-template-columns: 1fr; }
// `;

// const WeeklyCard = styled.div`
//   margin-top: 10px;
//   padding: 12px;
//   background: #fef2f2;
//   border-left: 4px solid #ef4444; 
//   border-radius: 12px;
// `;

// /* ================= SUMMARY ================= */
// const SummaryGrid = styled.div`
//   display: grid;
//   grid-template-columns: 1.2fr 1fr;
//   gap: 18px;

//   @media (max-width: 980px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const SummaryCard = styled.div`
//   border: 1px solid #e5e7eb;
//   border-radius: 16px;
//   padding: 24px;
//   background: white;
//   display: flex;
//   flex-direction: column;
// `;

// const SummaryCardTitle = styled.h4`
//   margin: 0 0 16px;
//   font-size: 1.1rem;
//   font-weight: 800;
//   color: #0f172a;
// `;

// const ScoreList = styled.div`
//   display: grid;
//   gap: 12px;
// `;

// const ScoreRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   padding: 14px 18px;
//   border-radius: 12px;
//   background: ${({ variant }) => getThemeColors(variant).thBg};
//   border: 1px solid ${({ variant }) => getThemeColors(variant).border};
// `;

// const ScoreLabel = styled.div`
//   font-size: 14px;
//   font-weight: 700;
//   color: ${({ variant }) => getThemeColors(variant).thText};
// `;

// const ScoreValueBox = styled.div`
//   font-size: 1.1rem;
//   font-weight: 900;
//   color: ${({ variant }) => getThemeColors(variant).thText};
// `;

// const BigGrade = styled.div`
//   font-size: clamp(2rem, 1.8rem + 1vw, 2.6rem);
//   font-weight: 900;
//   color: #1d4ed8; 
// `;

// const TextBlock = styled.div`
//   flex: 1;
//   min-height: 110px;
//   border: 1px solid #e2e8f0;
//   border-radius: 14px;
//   background: #f8fafc;
//   padding: 16px;
//   white-space: pre-wrap;
//   line-height: 1.7;
//   color: #334155;
//   resize: vertical;
//   overflow: auto;
// `;

// const GradeTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   border-radius: 12px;
//   overflow: hidden;
//   border: 1px solid #bfdbfe; 
//   font-size: 0.9rem;
//   background: white;
//   margin-top: auto;

//   th {
//     background: linear-gradient(135deg, #1e3a8a, #2563eb); 
//     color: white;
//     font-weight: 800;
//     padding: 14px;
//     text-align: left;
//     border-bottom: 2px solid #1e40af; 
//   }
//   td {
//     padding: 12px 14px;
//     border-bottom: 1px solid #dbeafe; 
//     color: #1e3a8a; 
//     font-weight: 700;
//   }
//   tr:last-child td { border-bottom: none; }
// `;

// /* ================= LOADING / EMPTY STATES ================= */
// const CenterState = styled.div`
//   min-height: 60vh;
//   display: grid;
//   place-items: center;
//   padding: 24px;
// `;

// const StateCard = styled.div`
//   width: min(460px, 100%);
//   background: rgba(255, 255, 255, 0.95);
//   border: 1px solid var(--border);
//   border-radius: 24px;
//   padding: 28px;
//   text-align: center;
//   box-shadow: var(--shadow-md);
// `;

// const Spinner = styled.div`
//   width: 46px;
//   height: 46px;
//   margin: 0 auto 18px;
//   border-radius: 50%;
//   border: 4px solid #dbeafe;
//   border-top-color: #2563eb;
//   animation: spin 0.8s linear infinite;

//   @keyframes spin {
//     to { transform: rotate(360deg); }
//   }
// `;

// const StateTitle = styled.h3`
//   margin: 0;
//   font-size: 1.1rem;
//   color: #0f172a;
// `;

// const StateText = styled.p`
//   margin: 10px 0 0;
//   color: var(--text-soft);
//   line-height: 1.6;
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 90px 20px;
//   color: #64748b;
//   background: white;
//   border-radius: 20px;
//   border: 1px dashed #cbd5e1;
// `;

// /* ================= COMPONENT ================= */
// const Records = ({ user, collapsed, setCollapsed }) => {
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [expandedId, setExpandedId] = useState("");

//   useEffect(() => {
//     const fetchRecords = async () => {
//       try {
//         const res = await api.get("/appraisal/all");
//         setRecords(res.data?.data || []);
//       } catch (err) {
//         console.error("Failed to fetch records", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRecords();
//   }, []);

//   const allTabs = useMemo(() => {
//     const tabs = [];
//     records.forEach((record) => {
//       const yearMatch = record.appraisalPeriod.match(/\d{4}/);
//       const year = yearMatch ? yearMatch[0] : ""; 
//       (record.section2 || []).forEach((m) => {
//         const monthName = m.month || "Unknown";
//         const displayYear = (year && !monthName.includes(year)) ? ` ${year}` : "";
//         tabs.push({
//           id: `${record.appraisalPeriod}-${monthName}`,
//           period: record.appraisalPeriod,
//           month: monthName,
//           label: `Performance Record for ${monthName}${displayYear}`,
//           record: record, 
//           monthData: m    
//         });
//       });
//     });
//     return tabs;
//   }, [records]);

//   const currentTab = useMemo(() => {
//     return allTabs.find(tab => tab.id === expandedId) || null;
//   }, [allTabs, expandedId]);

//   const exportData = useMemo(() => {
//     if (!currentTab) return null;
//     return {
//       appraisalPeriod: currentTab.record.appraisalPeriod,
//       selectedMonth: currentTab.month,
//       section2: currentTab.monthData || null,
//       section3: currentTab.record.section3 || [],
//       section4: currentTab.record.section4 || [],
//       summary: currentTab.record.summary || {},
//       staffFeedback: currentTab.record.staffFeedback || {},
//     };
//   }, [currentTab]);

//   const exportBaseName = `performance-record-${currentTab?.period || "record"}-${currentTab?.month || "month"}`;

//   const handleExportJSON = () => {
//     if (!exportData) return;
//     downloadBlob(JSON.stringify(exportData, null, 2), `${exportBaseName}.json`, "application/json");
//   };

//   const handleExportTXT = () => {
//     if (!exportData) return;
//     const txt = `
// PERFORMANCE RECORD
// Period: ${currentTab.period}
// Month: ${currentTab.month}

// SUMMARY
// Section 2: ${formatValue(exportData.summary?.section2, 0)}
// Section 3: ${formatValue(exportData.summary?.section3, 0)}
// Section 4: ${formatValue(exportData.summary?.section4, 0)}
// Cumulative: ${formatValue(exportData.summary?.cumulative, 0)}
// Grade: ${formatValue(exportData.summary?.grade, "—")}
// Supervisor's Grade: ${formatValue(exportData.summary?.supervisorGrade, "—")}

// CITATION
// ${formatValue(exportData.summary?.citation)}

// SUPERVISOR OVERALL COMMENTS
// ${formatValue(exportData.staffFeedback?.supervisorAttention)}
// `.trim();
//     downloadBlob(txt, `${exportBaseName}.txt`, "text/plain;charset=utf-8");
//   };

//   const handleExportCSV = () => {
//     if (!exportData) return;
//     const rows = [];
//     rows.push(["section", "group", "title", "achievement", "staffActionScore", "staffQualityScore", "supervisorActionScore", "supervisorQualityScore", "staffScore", "supervisorScore", "comments"].map(toCSVValue).join(","));
//     downloadBlob(rows.join("\n"), `${exportBaseName}.csv`, "text/csv;charset=utf-8");
//   };

//   const handlePrintPDF = () => window.print();

//   if (loading) {
//     return (
//       <Container collapsed={collapsed}>
//         <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//         <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
//         <CenterState><StateCard><Spinner /><StateTitle>Loading records</StateTitle></StateCard></CenterState>
//       </Container>
//     );
//   }
//   if (!records.length || allTabs.length === 0) {
//     return (
//       <Container collapsed={collapsed}>
//         <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//         <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
//         <Main>
//           <EmptyState>No records found yet.</EmptyState>
//         </Main>
//       </Container>
//     );
//   }
//   //NO SCORES FOR WEEKLY GOALS
//   return (
//     <Container collapsed={collapsed}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
//       <Main>
//         <HeroSection>
//           <HeroPanel>
//             <HeroTitle>Records</HeroTitle>
//             <HeroText>View your performance records fully displayed per period.</HeroText>
//           </HeroPanel>
//           <ExportWrap>
//             <ExportButton variant="primary" disabled={!expandedId} onClick={handlePrintPDF}>Export PDF</ExportButton>
//             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportCSV}>Export CSV</ExportButton>
//             <ExportButton variant="secondary" disabled={!expandedId} onClick={handleExportTXT}>Export TXT</ExportButton>
//           </ExportWrap>
//         </HeroSection>

//         <RecordList>
//           {allTabs.map((tab) => {
//             const isExpanded = expandedId === tab.id;
//             const recordData = tab.record;
//             const monthData = tab.monthData;

//             return (
//               <RecordItem key={tab.id} $expanded={isExpanded}>
//                 <RecordHeader $expanded={isExpanded} onClick={() => setExpandedId(isExpanded ? "" : tab.id)}>
//                   <RecordHeaderInfo>
//                     <RecordHeaderTitle>{tab.label}</RecordHeaderTitle>
//                     <RecordHeaderSub>Period: {tab.period}</RecordHeaderSub>
//                   </RecordHeaderInfo>
//                   <ViewButton $expanded={isExpanded}>{isExpanded ? "Close" : "View"}</ViewButton>
//                 </RecordHeader>

//                 {isExpanded && (
//                   <DocumentWrapper>
                    

//                     {/* SECTION 2 */}
//                     <SectionBlock>
//                       <SectionHeading variant="red">
//                         <SectionTitle>PERFORMANCE ON GOALS</SectionTitle>
//                       </SectionHeading>

//                       <SectionTitle style={{ marginBottom: 12, fontSize: '14px' }}>Major Goals - 60 Marks</SectionTitle>
//                       <TableWrap variant="red">
//                       <Table>
//                           <colgroup>
//                             <col style={{ width: "35px" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "110px" }} />
//                             <col style={{ width: "115px" }} />
//                             <col style={{ width: "150px" }} />
//                           </colgroup>
//                           <thead>
//                             <tr>
//                               <ThemedTh variant="red">S/N</ThemedTh>
//                               <ThemedTh variant="red">MAJOR GOALS</ThemedTh>
//                               <ThemedTh variant="red">ACHIEVEMENTS</ThemedTh>
//                               <ThemedTh variant="red">YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
//                               <ThemedTh variant="red">YOUR SCORE ON QUALITY (0-5)</ThemedTh>
//                               <ThemedTh variant="red">SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
//                               <ThemedTh variant="red">SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
//                               <ThemedTh variant="red">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(monthData?.majorGoals || []).map((goal, index) => (
//                               <React.Fragment key={index}>
//                                 <tr>
//                                   <td>{index + 1}</td>
//                                   <td><DisabledInput>{formatValue(goal.goal)}</DisabledInput></td>
//                                   <td><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></td>
//                                   <td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></td>
//                                   <td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
//                                   <td><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
//                                   <td><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
//                                   <td>
//                                     <textarea 
//                                       readOnly 
//                                       value={formatValue(goal.supervisorComments)} 
//                                       style={{
//                                         width: "100%", minHeight: "45px", padding: "6px 8px", 
//                                         border: "1px solid #e2e8f0", borderRadius: "6px", 
//                                         background: "#f8fafc", color: "#334155", 
//                                         fontSize: "12px", lineHeight: "1.4", 
//                                         resize: "vertical", boxSizing: "border-box", 
//                                         outline: "none", fontFamily: "inherit"
//                                       }} 
//                                     />
//                                   </td>
//                                 </tr>
//                                 {(goal.weekly || []).map((week, weekIndex) => (
//                                   <WeeklyRow key={`${index}-${weekIndex}`}>
//                                     <td></td>
//                                     <td>
//                                       <strong>{formatValue(week.week, `Week ${weekIndex + 1}`)}</strong>
//                                       <div style={{ marginTop: 8 }}>{formatValue(week.weeklyGoal)}</div>
//                                     </td>
//                                     <td>{formatValue(week.weeklyAchievement)}</td>
//                                     <td colSpan="5" style={{ opacity: 0.6, fontSize: '10px' }}></td>
//                                   </WeeklyRow>
//                                 ))}
//                               </React.Fragment>
//                             ))}
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffActionScore), 0)}</td>
//                               <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffQualityScore), 0)}</td>
//                               {/* <td>{formatValue(monthData?.majorSumA, 0)}</td>
//                               <td>{formatValue(monthData?.majorSumQ, 0)}</td> */}
//                               <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorActionScore), 0)}</td>
//                               <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorQualityScore), 0)}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">SCORE (SS/GOALS)</td>
//                               <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.majorGoals || []; 
//                                 const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
//                                 return ((avgA + avgQ) / 2).toFixed(2);
//                               })()}</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.majorGoals || []; 
//                                 const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
//                                 return ((avgA + avgQ) / 2).toFixed(2);
//                               })()}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="red">
//                               <td colSpan="3">TOTAL SCORE (CS/5 × 60 Marks)</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.majorGoals || []; 
//                                 const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
//                                 const cs = (avgA + avgQ) / 2;
//                                 return ((cs / 5) * 60).toFixed(1);
//                               })()} / 60</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.majorGoals || []; 
//                                 const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
//                                 const cs = (avgA + avgQ) / 2;
//                                 return ((cs / 5) * 60).toFixed(1);
//                               })()} / 60</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR MAJOR GOALS */}
//                       <CardGrid>
//                         {(monthData?.majorGoals || []).map((goal, index) => (
//                           <RecordCard variant="red" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="red">{index + 1}</RecordIndex>
//                               <RecordLabel variant="red">Major Goal</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
//                               {(goal.weekly || []).map((week, weekIndex) => (
//                                 <WeeklyCard key={weekIndex}>
//                                   <FieldTitle>{formatValue(week.week, `Week ${weekIndex + 1}`)}</FieldTitle>
//                                   <div>{formatValue(week.weeklyGoal)}</div>
//                                   <div style={{ marginTop: 8, color: "#64748b" }}>{formatValue(week.weeklyAchievement)}</div>
//                                 </WeeklyCard>
//                               ))}
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>

//                       <SectionTitle style={{ marginBottom: 12, fontSize: '14px' }}>Other Goals - 15 Marks</SectionTitle>
//                       <TableWrap variant="orange">
//                       <Table>
//                           <colgroup>
//                             <col style={{ width: "35px" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "auto" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "85px" }} />
//                             <col style={{ width: "110px" }} />
//                             <col style={{ width: "115px" }} />
//                             <col style={{ width: "150px" }} />
//                           </colgroup>
//                           <thead>
//                             <tr>
//                               <ThemedTh variant="orange">S/N</ThemedTh>
//                               <ThemedTh variant="orange">MAJOR GOALS</ThemedTh>
//                               <ThemedTh variant="orange">ACHIEVEMENTS</ThemedTh>
//                               <ThemedTh variant="orange">YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">YOUR SCORE ON QUALITY (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
//                               <ThemedTh variant="orange">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(monthData?.otherGoals || []).map((goal, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td><DisabledInput>{formatValue(goal.goal)}</DisabledInput></td>
//                                 <td><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></td>
//                                 <td><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></td>
//                                 <td><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
//                                 <td><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
//                                 <td><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
//                                 <td>
//                                   <textarea 
//                                     readOnly 
//                                     value={formatValue(goal.supervisorComments)} 
//                                     style={{
//                                       width: "100%", minHeight: "45px", padding: "6px 8px", 
//                                       border: "1px solid #e2e8f0", borderRadius: "6px", 
//                                       background: "#f8fafc", color: "#334155", 
//                                       fontSize: "12px", lineHeight: "1.4", 
//                                       resize: "vertical", boxSizing: "border-box", 
//                                       outline: "none", fontFamily: "inherit"
//                                     }} 
//                                   />
//                                 </td>
//                               </tr>
//                             ))}
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               {/* <td>{formatValue(monthData?.otherSumA, 0)}</td>
//                               <td>{formatValue(monthData?.otherSumQ, 0)}</td> */}
//                               <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffActionScore), 0)}</td>
//                               <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffQualityScore), 0)}</td>
//                               <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorActionScore), 0)}</td>
//                               <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorQualityScore), 0)}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">SCORE (SS/GOALS)</td>
//                               <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.otherGoals || []; 
//                                 const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
//                                 return ((avgA + avgQ) / 2).toFixed(2);
//                               })()}</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.otherGoals || []; 
//                                 const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
//                                 return ((avgA + avgQ) / 2).toFixed(2);
//                               })()}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="orange">
//                               <td colSpan="3">TOTAL SCORE (CS/5 × 15 Marks)</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.otherGoals || []; 
//                                 const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
//                                 const cs = (avgA + avgQ) / 2;
//                                 return ((cs / 5) * 15).toFixed(1);
//                               })()} / 15</td>
//                               <td colSpan="2">{(() => { 
//                                 const goals = monthData?.otherGoals || []; 
//                                 const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
//                                 const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
//                                 const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
//                                 const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
//                                 const cs = (avgA + avgQ) / 2;
//                                 return ((cs / 5) * 15).toFixed(1);
//                               })()} / 15</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR OTHER GOALS */}
//                       <CardGrid>
//                         {(monthData?.otherGoals || []).map((goal, index) => (
//                           <RecordCard variant="orange" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="orange">{index + 1}</RecordIndex>
//                               <RecordLabel variant="orange">Other Goal</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Supervisor's  Comments</FieldTitle><DisabledInput>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>
//                     </SectionBlock>

//                     {/* SECTION 3 */}
//                     <SectionBlock>
//                       <SectionHeading variant="purple">
//                         <SectionTitle>WORK ETHIC & LEADERSHIP</SectionTitle>
//                       </SectionHeading>
//                       <TableWrap variant="purple">
//                         <Table>
//                           <colgroup>
//                             <col style={{ width: "4%" }} />
//                             <col style={{ width: "16%" }} />
//                             <col style={{ width: "22%" }} />
//                             <col style={{ width: "10%" }} />
//                             <col style={{ width: "19%" }} />
//                             <col style={{ width: "12%" }} />
//                             <col style={{ width: "19%" }} />
//                           </colgroup>
//                           <thead>
//                             <tr>
//                               <ThemedTh variant="purple">S/N</ThemedTh>
//                               <ThemedTh variant="purple">ATTRIBUTE</ThemedTh>
//                               <ThemedTh variant="purple">DESCRIPTION</ThemedTh>
//                               <ThemedTh variant="purple">YOUR SCORE</ThemedTh>
//                               <ThemedTh variant="purple">YOUR COMMENTS</ThemedTh>
//                               <ThemedTh variant="purple">SUPERVISOR&apos;S<br/>SCORE</ThemedTh>
//                               <ThemedTh variant="purple">SUPERVISOR'S   COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(recordData?.section3 || []).map((item, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
//                                 <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
//                                 <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
//                                 <td>
//                                   <textarea 
//                                     readOnly 
//                                     value={formatValue(item.staffComments)} 
//                                     style={{
//                                       width: "100%", minHeight: "45px", padding: "6px 8px", 
//                                       border: "1px solid #e2e8f0", borderRadius: "6px", 
//                                       background: "#f8fafc", color: "#334155", 
//                                       fontSize: "12px", lineHeight: "1.4", 
//                                       resize: "vertical", boxSizing: "border-box", 
//                                       outline: "none", fontFamily: "inherit"
//                                     }} 
//                                   />
//                                 </td>
//                                 <td><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></td>
//                                 <td>
//                                   <textarea 
//                                     readOnly 
//                                     value={formatValue(item.supervisorComments)} 
//                                     style={{
//                                       width: "100%", minHeight: "45px", padding: "6px 8px", 
//                                       border: "1px solid #e2e8f0", borderRadius: "6px", 
//                                       background: "#f8fafc", color: "#334155", 
//                                       fontSize: "12px", lineHeight: "1.4", 
//                                       resize: "vertical", boxSizing: "border-box", 
//                                       outline: "none", fontFamily: "inherit"
//                                     }} 
//                                   />
//                                 </td>
//                               </tr>
//                             ))}
//                             <ThemedTotalsRow variant="purple">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{(recordData?.section3 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
//                               <td></td>
//                               <td>{(recordData?.section3 || []).reduce((acc, item) => { const num = Number(item.supervisorScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="purple">
//                               <td colSpan="3">SCORE (SS/10)</td>
//                               <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td></td>
//                               <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="purple">
//                               <td colSpan="3">TOTAL SCORE (SCORE/5 × 15 Marks)</td>
//                               <td colSpan="2">{formatValue(recordData?.summary?.section3, 0)} / 20</td>
//                               <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); const avg = valid.length ? (sum / valid.length) : 0; return ((avg / 5) * 20).toFixed(1); })()} / 20</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR WORK ETHIC */}
//                       <CardGrid>
//                         {(recordData?.section3 || []).map((item, index) => (
//                           <RecordCard variant="purple" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="purple">{index + 1}</RecordIndex>
//                               <RecordLabel variant="purple">Work Ethic</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Attribute</FieldTitle><DisabledInput>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput>{formatValue(item.description)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>
//                     </SectionBlock>

//                     {/* SECTION 4 */}
//                     <SectionBlock>
//                       <SectionHeading variant="green">
//                         <SectionTitle>COMPLIANCE</SectionTitle>
//                       </SectionHeading>
//                       <TableWrap variant="green">
//                       <Table>
//                           <colgroup>
//                             <col style={{ width: "5%" }} />
//                             <col style={{ width: "15%" }} />
//                             <col style={{ width: "25%" }} />
//                             <col style={{ width: "10%" }} />
//                             <col style={{ width: "18%" }} />
//                             <col style={{ width: "12%" }} />
//                             <col style={{ width: "17%" }} />
//                           </colgroup>
//                           <thead>
//                             <tr>
//                               <ThemedTh variant="green">S/N</ThemedTh>
//                               <ThemedTh variant="green">PROTOCOL</ThemedTh>
//                               <ThemedTh variant="green">DESCRIPTION</ThemedTh>
//                               <ThemedTh variant="green">YOUR SCORE</ThemedTh>
//                               <ThemedTh variant="green">YOUR COMMENTS</ThemedTh>
//                               <ThemedTh variant="green">SUPERVISOR'S SCORE</ThemedTh>
//                               <ThemedTh variant="green">SUPERVISOR'S COMMENTS</ThemedTh>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {(recordData?.section4 || []).map((item, index) => (
//                               <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td><DisabledInput>{formatValue(item.attribute)}</DisabledInput></td>
//                                 <td><DisabledInput>{formatValue(item.description)}</DisabledInput></td>
//                                 <td><SmallScore>{scoreValue(item.staffScore)}</SmallScore></td>
//                                 <td>
//                                   <textarea 
//                                     readOnly 
//                                     value={formatValue(item.staffComments)} 
//                                     style={{
//                                       width: "100%", minHeight: "45px", padding: "6px 8px", 
//                                       border: "1px solid #e2e8f0", borderRadius: "6px", 
//                                       background: "#f8fafc", color: "#334155", 
//                                       fontSize: "12px", lineHeight: "1.4", 
//                                       resize: "vertical", boxSizing: "border-box", 
//                                       outline: "none", fontFamily: "inherit"
//                                     }} 
//                                   />
//                                 </td>
//                                 <td><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></td>
//                                 <td>
//                                   <textarea 
//                                     readOnly 
//                                     value={formatValue(item.supervisorComments)} 
//                                     style={{
//                                       width: "100%", minHeight: "45px", padding: "6px 8px", 
//                                       border: "1px solid #e2e8f0", borderRadius: "6px", 
//                                       background: "#f8fafc", color: "#334155", 
//                                       fontSize: "12px", lineHeight: "1.4", 
//                                       resize: "vertical", boxSizing: "border-box", 
//                                       outline: "none", fontFamily: "inherit"
//                                     }} 
//                                   />
//                                 </td>
//                               </tr>
//                             ))}
//                             <ThemedTotalsRow variant="green">
//                               <td colSpan="3">SUM OF SCORES (SS)</td>
//                               <td>{(recordData?.section4 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
//                               <td></td>
//                               <td>{(recordData?.section4 || []).reduce((acc, item) => { const num = Number(item.supervisorScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="green">
//                               <td colSpan="3">SCORE (SS/13)</td>
//                               <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td></td>
//                               <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                             <ThemedTotalsRow variant="green">
//                               <td colSpan="3">TOTAL SCORE (SCORE/5 × 10 Marks)</td>
//                               <td colSpan="2">{formatValue(recordData?.summary?.section4, 0)} / 10</td>
//                               <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); const avg = valid.length ? (sum / valid.length) : 0; return ((avg / 5) * 10).toFixed(1); })()} / 10</td>
//                               <td></td>
//                             </ThemedTotalsRow>
//                           </tbody>
//                         </Table>
//                       </TableWrap>

//                       {/* MOBILE VIEW CARDS FOR COMPLIANCE */}
//                       <CardGrid>
//                         {(recordData?.section4 || []).map((item, index) => (
//                           <RecordCard variant="green" key={index}>
//                             <RecordCardHead>
//                               <RecordIndex variant="green">{index + 1}</RecordIndex>
//                               <RecordLabel variant="green">Compliance</RecordLabel>
//                             </RecordCardHead>
//                             <RecordFields>
//                               <FieldBlock><FieldTitle>Protocol</FieldTitle><DisabledInput>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput>{formatValue(item.description)}</DisabledInput></FieldBlock>
//                               <CompactScoreGrid>
//                                 <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
//                                 <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
//                               </CompactScoreGrid>
//                               <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
//                               <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
//                             </RecordFields>
//                           </RecordCard>
//                         ))}
//                       </CardGrid>
//                     </SectionBlock>

//                     {/* CITATIONS SECTION (MOVED ABOVE SUMMARY) */}
//                     <SectionBlock>
//                       <SectionHeading variant="blue">
//                         <SectionTitle>CITATIONS OF YOUR ACHIEVEMENTS</SectionTitle>
//                       </SectionHeading>
//                       <TextBlock style={{ minHeight: "80px" }}>{formatValue(recordData?.summary?.citation)}</TextBlock>
//                     </SectionBlock>

//                     {/* NEW SPLIT SUMMARY SECTION */}
//                     <SectionBlock>
//                       <SectionHeading variant="blue">
//                         <SectionTitle>SUMMARY</SectionTitle>
//                       </SectionHeading>
                      
//                       {/* Set columns to 1fr 1fr to ensure both breakdowns are perfectly equal in width */}
//                       <SummaryGrid style={{ gridTemplateColumns: "1fr 1fr" }}>
                        
//                         {/* LEFT COLUMN: YOUR SCORES & GRADE */}
//                         <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
//                           <SummaryCard>
//                             <SummaryCardTitle>Your Total Score Breakdown</SummaryCardTitle>
//                             <ScoreList>
//                               <ScoreRow variant="red">
//                                 <ScoreLabel variant="red">Goals</ScoreLabel>
//                                 <ScoreValueBox variant="red">{formatValue(recordData?.summary?.section2, 0)}</ScoreValueBox>
//                               </ScoreRow>
//                               <ScoreRow variant="purple">
//                                 <ScoreLabel variant="purple">Ethics</ScoreLabel>
//                                 <ScoreValueBox variant="purple">{formatValue(recordData?.summary?.section3, 0)}</ScoreValueBox>
//                               </ScoreRow>
//                               <ScoreRow variant="green">
//                                 <ScoreLabel variant="green">Compliance</ScoreLabel>
//                                 <ScoreValueBox variant="green">{formatValue(recordData?.summary?.section4, 0)}</ScoreValueBox>
//                               </ScoreRow>
//                               <ScoreRow variant="dark">
//                                 <ScoreLabel variant="dark">Your Performance Score</ScoreLabel>
//                                 <ScoreValueBox variant="dark">{formatValue(recordData?.summary?.cumulative, 0)}</ScoreValueBox>
//                               </ScoreRow>
//                             </ScoreList>
//                           </SummaryCard>

//                           <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
//                             <div style={{ fontSize: 13, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Your Grade</div>
//                             <BigGrade>{formatValue(recordData?.summary?.grade, "—")}</BigGrade>
//                           </SummaryCard>
//                         </div>

//                         {/* RIGHT COLUMN: SUPERVISOR SCORES & GRADE */}
//                         <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
//                           <SummaryCard>
//                             <SummaryCardTitle>Supervisor's Score Breakdown</SummaryCardTitle>
//                             <ScoreList>
//                               {/* Assumes backend passes supervisorSection2, etc. If not, it falls back to "—" */}
//                               <ScoreRow variant="red">
//                                 <ScoreLabel variant="red">Goals</ScoreLabel>
//                                 <ScoreValueBox variant="red">{formatValue(recordData?.summary?.supervisorSection2, "—")}</ScoreValueBox>
//                               </ScoreRow>
//                               <ScoreRow variant="purple">
//                                 <ScoreLabel variant="purple">Ethics</ScoreLabel>
//                                 <ScoreValueBox variant="purple">{formatValue(recordData?.summary?.supervisorSection3, "—")}</ScoreValueBox>
//                               </ScoreRow>
//                               <ScoreRow variant="green">
//                                 <ScoreLabel variant="green">Compliance</ScoreLabel>
//                                 <ScoreValueBox variant="green">{formatValue(recordData?.summary?.supervisorSection4, "—")}</ScoreValueBox>
//                               </ScoreRow>
//                               <ScoreRow variant="dark">
//                                 <ScoreLabel variant="dark">Supervisor Cumulative</ScoreLabel>
//                                 <ScoreValueBox variant="dark">{formatValue(recordData?.summary?.supervisorCumulative, "—")}</ScoreValueBox>
//                               </ScoreRow>
//                             </ScoreList>
//                           </SummaryCard>

//                           <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
//                             <div style={{ fontSize: 13, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Supervisor Grade</div>
//                             <BigGrade style={{ color: "#0f766e" }}>{formatValue(recordData?.summary?.supervisorGrade, "—")}</BigGrade>
//                           </SummaryCard>
//                         </div>
//                       </SummaryGrid>

//                       {/* GRADING SCALE (MOVED TO BOTTOM OF SUMMARY) */}
//                       <SummaryCard style={{ marginTop: '18px' }}>
//                         <SummaryCardTitle>Grading Scale</SummaryCardTitle>
//                         <GradeTable>
//                           <thead><tr><th>SCORE RANGE</th><th>GRADE</th></tr></thead>
//                           <tbody>
//                             <tr><td>80% - Above</td><td>A</td></tr>
//                             <tr><td>70% - 79%</td><td>B</td></tr>
//                             <tr><td>60% - 69%</td><td>C</td></tr>
//                             <tr><td>50% - 59%</td><td>D</td></tr>
//                             <tr><td>49% - Below</td><td>E</td></tr>
//                           </tbody>
//                         </GradeTable>
//                       </SummaryCard>
//                     </SectionBlock>

//                     <SectionBlock>
//                       <SectionHeading variant="blue">
//                         <SectionTitle>SUPERVISOR&apos;S OVERALL COMMENTS</SectionTitle>
//                       </SectionHeading>
//                       <TextBlock>{formatValue(recordData?.staffFeedback?.supervisorAttention)}</TextBlock>
//                     </SectionBlock>

//                     {/* NEW HEAD OF DEPARTMENT COMMENTS SECTION */}
//                     <SectionBlock>
//                       <SectionHeading variant="blue">
//                         <SectionTitle>HEAD OF DEPARTMENT&apos;S OVERALL COMMENTS</SectionTitle>
//                       </SectionHeading>
//                       <TextBlock>{formatValue(recordData?.summary?.hodOverallComments)}</TextBlock>
//                     </SectionBlock>

      
                

//                   </DocumentWrapper>
//                 )}
//               </RecordItem>
//             );
//           })}
//         </RecordList>
//          <Footer />
//       </Main>
//     </Container>
//   );
// };

// export default Records;


import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Navbar from "./Navbar";
import DashboardHeader from "./DashboardHeader";
import api from "../api";
import Footer from "./Footer";
import { useTheme } from "../App"; // 🔥 Import the global theme hook

/* ================= HELPERS ================= */
const formatValue = (value, fallback = "—") => {
  if (value === null || value === undefined || value === "") return fallback;
  return value;
};

const scoreValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  return value;
};

const safeNumber = (value) => {
  const num = Number(value);
  return Number.isNaN(num) ? 0 : num;
};

const downloadBlob = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

const toCSVValue = (value) => {
  const stringValue = String(value ?? "");
  return `"${stringValue.replace(/"/g, '""')}"`;
};

/* ================= THEME UTILITY ================= */
// 🔥 Updated to handle Dark Mode
const getThemeColors = (variant, isDarkMode) => {
  if (isDarkMode) {
    switch (variant) {
      case "orange":
        return { 
          thBg: "rgba(234, 88, 12, 0.1)", thText: "#fdba74", border: "#9a3412", rowBg: "rgba(234, 88, 12, 0.05)", 
          heading: "linear-gradient(135deg, #7c2d12, #9a3412)", pillBg: "rgba(234, 88, 12, 0.2)", pillText: "#fdba74" 
        };
      case "purple":
        return { 
          thBg: "rgba(139, 92, 246, 0.1)", thText: "#c4b5fd", border: "#4c1d95", rowBg: "rgba(139, 92, 246, 0.05)", 
          heading: "linear-gradient(135deg, #4c1d95, #5b21b6)", pillBg: "rgba(139, 92, 246, 0.2)", pillText: "#c4b5fd" 
        };
      case "green":
        return { 
          thBg: "rgba(34, 197, 94, 0.1)", thText: "#86efac", border: "#14532d", rowBg: "rgba(34, 197, 94, 0.05)", 
          heading: "linear-gradient(135deg, #14532d, #166534)", pillBg: "rgba(34, 197, 94, 0.2)", pillText: "#86efac" 
        };
      case "dark":
        return {
          thBg: "rgba(255, 255, 255, 0.05)", thText: "#f8fafc", border: "#334155", rowBg: "rgba(255, 255, 255, 0.02)",
          heading: "linear-gradient(135deg, #1e293b, #334155)", pillBg: "rgba(255, 255, 255, 0.1)", pillText: "#f8fafc"
        };
      case "red": 
        return {
          thBg: "rgba(239, 68, 68, 0.1)", thText: "#fca5a5", border: "#7f1d1d", rowBg: "rgba(239, 68, 68, 0.05)",
          heading: "linear-gradient(135deg, #7f1d1d, #991b1b)", pillBg: "rgba(239, 68, 68, 0.2)", pillText: "#fca5a5"
        };
      default: // Blue
        return { 
          thBg: "rgba(59, 130, 246, 0.1)", thText: "#93c5fd", border: "#1e3a8a", rowBg: "rgba(59, 130, 246, 0.05)", 
          heading: "linear-gradient(135deg, #1e3a8a, #1d4ed8)", pillBg: "rgba(59, 130, 246, 0.2)", pillText: "#93c5fd" 
        };
    }
  } else {
    // Light Mode (Original)
    switch (variant) {
      case "orange":
        return { 
          thBg: "#fff7ed", thText: "#9a3412", border: "#fed7aa", rowBg: "#ffedd5", 
          heading: "linear-gradient(135deg, #7c2d12, #ea580c)", pillBg: "#ffedd5", pillText: "#ea580c" 
        };
      case "purple":
        return { 
          thBg: "#f5f3ff", thText: "#5b21b6", border: "#ddd6fe", rowBg: "#ede9fe", 
          heading: "linear-gradient(135deg, #4c1d95, #8b5cf6)", pillBg: "#ede9fe", pillText: "#7c3aed" 
        };
      case "green":
        return { 
          thBg: "#f0fdf4", thText: "#15803d", border: "#bbf7d0", rowBg: "#dcfce7", 
          heading: "linear-gradient(135deg, #14532d, #22c55e)", pillBg: "#dcfce7", pillText: "#16a34a" 
        };
      case "dark":
        return {
          thBg: "#f8fafc", thText: "#0f172a", border: "#e2e8f0", rowBg: "#f1f5f9",
          heading: "linear-gradient(135deg, #0f172a, #334155)", pillBg: "#e2e8f0", pillText: "#0f172a"
        };
      case "red": 
        return {
          thBg: "#fef2f2", thText: "#991b1b", border: "#fca5a5", rowBg: "#fee2e2",
          heading: "linear-gradient(135deg, #7f1d1d, #ef4444)", pillBg: "#fee2e2", pillText: "#dc2626"
        };
      default: // Blue
        return { 
          thBg: "#eff6ff", thText: "#1e40af", border: "#bfdbfe", rowBg: "#dbeafe", 
          heading: "linear-gradient(135deg, #1e3a8a, #3b82f6)", pillBg: "#dbeafe", pillText: "#2563eb" 
        };
    }
  }
};

/* ================= LAYOUT ================= */
const Container = styled.div`
  --sidebar-expanded: 260px;
  --sidebar-collapsed: 90px;
  
  /* 🔥 THEME VARIABLES 🔥 */
  --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
  --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
  --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
  --shadow-lg: 0 22px 55px rgba(0, 0, 0, 0.15);

  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text-main);
  margin-left: ${({ collapsed }) =>
    collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
  transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

  @media (max-width: 1024px) {
    margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")};
  }

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const Main = styled.main`
  width: min(1450px, calc(100% - 32px));
  margin: 0 auto;
  padding: 90px 24px 60px; 

  @media (max-width: 1024px) {
    width: min(100%, calc(100% - 24px));
    padding: 84px 20px 40px;
  }

  @media (max-width: 576px) {
    width: min(100%, calc(100% - 16px));
    padding: 80px 16px 28px;
  }
`;

/* ================= HERO & EXPORT ================= */
const HeroSection = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const HeroPanel = styled.div`
  flex: 1;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  padding: 28px;
  border-radius: 28px;
  box-shadow: var(--shadow-lg);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 183px;
  &::before {
    content: ""; position: absolute; right: -30px; bottom: -60px; width: 180px; height: 170px;
    border-radius: 50%; background: rgba(255, 255, 255, 0.08);
  }
`;

const HeroTitle = styled.h1`
  margin: 0; font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; margin-bottom: 75px; position: relative; z-index: 1;
`;

const HeroText = styled.p`
  margin: 0; color: rgba(255, 255, 255, 0.9); line-height: 1.65; font-size: 1.05rem; position: absolute; margin-top: 25px; z-index: 1;
`;

const ExportWrap = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 12px; min-width: 280px;
  @media (max-width: 900px) { display: flex; flex-wrap: wrap; }
`;

const ExportButton = styled.button`
  appearance: none; border: none; outline: none; border-radius: 12px; padding: 14px 16px;
  background: ${({ variant, $isDarkMode }) =>
    variant === "primary" ? "linear-gradient(135deg, #1d4ed8, #3b82f6)" : ($isDarkMode ? '#0f172a' : "white")};
  color: ${({ variant, disabled, $isDarkMode }) => (disabled ? "var(--text-soft)" : variant === "primary" ? "white" : "var(--text-main)")};
  border: ${({ variant, disabled, $isDarkMode }) => (disabled ? "1px solid var(--border)" : variant === "primary" ? "none" : `1px solid ${$isDarkMode ? '#334155' : '#cbd5e1'}`)};
  box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 4px 12px rgba(37, 99, 235, 0.2)" : "0 2px 4px rgba(0, 0, 0, 0.1)")};
  font-size: 14px; font-weight: 800; cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.3s ease, border 0.3s ease; text-align: center;

  &:hover {
    transform: ${({ disabled }) => (disabled ? "none" : "translateY(-2px)")};
    box-shadow: ${({ variant, disabled }) => (disabled ? "none" : variant === "primary" ? "0 6px 16px rgba(37, 99, 235, 0.3)" : "0 4px 8px rgba(0, 0, 0, 0.15)")};
  }
  @media (max-width: 900px) { flex: 1; min-width: 120px; }
`;

/* ================= ACCORDION LIST STYLES ================= */
const RecordList = styled.div` display: flex; flex-direction: column; gap: 16px; `;

const RecordItem = styled.div`
  background: var(--card-bg); border-radius: 20px; 
  border: 1px solid ${({ $expanded, $isDarkMode }) => ($expanded ? ($isDarkMode ? "#3b82f6" : "#bfdbfe") : "var(--border)")};
  box-shadow: ${({ $expanded }) => ($expanded ? "0 12px 30px rgba(0, 0, 0, 0.15)" : "0 4px 12px rgba(0, 0, 0, 0.05)")};
  overflow: hidden; transition: all 0.3s ease;
`;

const RecordHeader = styled.div`
  display: flex; justify-content: space-between; align-items: center; padding: 20px 24px;
  background: ${({ $expanded, $isDarkMode }) => ($expanded ? ($isDarkMode ? "rgba(59, 130, 246, 0.1)" : "#eff6ff") : "transparent")};
  cursor: pointer; transition: background 0.2s ease;
  &:hover { background: ${({ $isDarkMode }) => $isDarkMode ? "rgba(255,255,255,0.02)" : "#f8fafc"}; }
  @media (max-width: 576px) { flex-direction: column; align-items: flex-start; gap: 16px; padding: 16px; }
`;

const RecordHeaderInfo = styled.div` display: flex; flex-direction: column; gap: 6px; `;

const RecordHeaderTitle = styled.h3` margin: 0; font-size: 1.15rem; font-weight: 800; color: var(--text-main); `;
const RecordHeaderSub = styled.p` margin: 0; font-size: 0.9rem; color: var(--text-soft); font-weight: 600; `;

const ViewButton = styled.button`
  appearance: none;
  background: ${({ $expanded, $isDarkMode }) => ($expanded ? ($isDarkMode ? "rgba(255,255,255,0.1)" : "#e2e8f0") : "linear-gradient(135deg, #1d4ed8, #3b82f6)")};
  color: ${({ $expanded, $isDarkMode }) => ($expanded ? "var(--text-main)" : "white")};
  border: none; padding: 10px 24px; border-radius: 12px; font-weight: 800; font-size: 0.95rem; cursor: pointer; transition: transform 0.2s ease;
  &:hover { transform: translateY(-2px); }
  @media (max-width: 576px) { width: 100%; }
`;

const DocumentWrapper = styled.div`
  padding: 28px; border-top: 1px solid var(--border); background: var(--card-bg);
  @media (max-width: 576px) { padding: 16px; }
`;

/* ================= DOCUMENT INNER STYLES ================= */
const SectionBlock = styled.section` margin-top: 28px; `;

const SectionHeading = styled.div`
  background: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).heading};
  color: white; border-radius: 16px; padding: 14px 18px; margin-bottom: 16px;
`;

const SectionTitle = styled.h3` font-size: 18px; font-weight: 800; margin: 0 0 4px; `;

/* ================= COMPACT TABLE STYLES ================= */
const TableWrap = styled.div`
  overflow-x: hidden; 
  border: 1px solid ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).border};
  border-radius: 16px; margin-bottom: 18px; width: 100%;
  @media (max-width: 900px) { display: none; }
`;

const Table = styled.table`
  width: 100%; border-collapse: collapse; table-layout: fixed; 
  th, td { border-bottom: 1px solid var(--border); vertical-align: top; padding: 8px 6px; font-size: 12px; word-wrap: break-word; overflow-wrap: break-word; }
`;

const ThemedTh = styled.th`
  background: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thBg};
  color: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thText};
  font-weight: 800; border-bottom: 2px solid ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).border};
  border-right: 1px solid ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).border};
  padding: 10px 6px; text-align: left; font-size: 11px; text-transform: uppercase; line-height: 1.3;
  &:last-child { border-right: none; }
`;

const WeeklyRow = styled.tr`
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.05)' : '#fef2f2'}; 
  td { font-size: 11px; color: var(--text-main); }
`;

const ThemedTotalsRow = styled.tr`
  background: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).rowBg};
  td { font-weight: 800; color: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thText}; font-size: 12px; }
`;

const DisabledInput = styled.div`
  min-height: 32px; border: 1px solid var(--input-border); background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'};
  color: var(--text-main); border-radius: 6px; padding: 6px 8px; line-height: 1.4; white-space: pre-wrap; font-size: 12px; overflow: hidden; 
`;

const SmallScore = styled.div`
  width: 32px; height: 32px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px;
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#dbe3ee'}; 
  background: ${(props) => props.muted ? (props.$isDarkMode ? 'transparent' : '#f8fafc') : (props.$isDarkMode ? 'rgba(59, 130, 246, 0.2)' : '#eef2ff')}; 
  font-weight: 800; color: var(--text-main); font-size: 12px;
`;

/* ================= MOBILE/TABLET CARDS ================= */
const CardGrid = styled.div`
  display: none; @media (max-width: 900px) { display: grid; gap: 16px; margin-bottom: 18px; }
`;

const RecordCard = styled.div`
  border: 1px solid ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).border};
  border-left: 5px solid ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).pillText};
  background: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thBg};
  border-radius: 18px; padding: 16px; box-shadow: 0 8px 22px rgba(0,0,0,0.05);
`;

const RecordCardHead = styled.div` display: flex; justify-content: space-between; gap: 10px; align-items: flex-start; flex-wrap: wrap; margin-bottom: 14px; `;

const RecordIndex = styled.div`
  width: 34px; height: 34px; border-radius: 50%; display: grid; place-items: center; font-weight: 800;
  background: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).pillBg};
  color: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).pillText};
`;

const RecordLabel = styled.div`
  font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.04em;
  color: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).pillText};
`;

const RecordFields = styled.div` display: grid; gap: 12px; `;
const FieldBlock = styled.div``;
const FieldTitle = styled.div` font-size: 12px; font-weight: 800; color: var(--text-soft); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px; `;

const CompactScoreGrid = styled.div` display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; @media (max-width: 420px) { grid-template-columns: 1fr; } `;

const WeeklyCard = styled.div`
  margin-top: 10px; padding: 12px; border-radius: 12px;
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(239, 68, 68, 0.05)' : '#fef2f2'};
  border-left: 4px solid #ef4444; 
`;

/* ================= SUMMARY ================= */
const SummaryGrid = styled.div` display: grid; grid-template-columns: 1.2fr 1fr; gap: 18px; @media (max-width: 980px) { grid-template-columns: 1fr; } `;

const SummaryCard = styled.div`
  border: 1px solid var(--border); border-radius: 16px; padding: 24px; background: var(--card-bg); display: flex; flex-direction: column;
`;

const SummaryCardTitle = styled.h4` margin: 0 0 16px; font-size: 1.1rem; font-weight: 800; color: var(--text-main); `;
const ScoreList = styled.div` display: grid; gap: 12px; `;

const ScoreRow = styled.div`
  display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 14px 18px; border-radius: 12px;
  background: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thBg};
  border: 1px solid ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).border};
`;

const ScoreLabel = styled.div` font-size: 14px; font-weight: 700; color: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thText}; `;
const ScoreValueBox = styled.div` font-size: 1.1rem; font-weight: 900; color: ${({ variant, $isDarkMode }) => getThemeColors(variant, $isDarkMode).thText}; `;

const BigGrade = styled.div` font-size: clamp(2rem, 1.8rem + 1vw, 2.6rem); font-weight: 900; color: #3b82f6;  `;

const TextBlock = styled.div`
  flex: 1; min-height: 110px; border: 1px solid var(--input-border); border-radius: 14px; padding: 16px; white-space: pre-wrap; line-height: 1.7; resize: vertical; overflow: auto;
  background: ${({ $isDarkMode }) => $isDarkMode ? 'var(--input-bg)' : '#f8fafc'}; color: var(--text-main); 
`;

const GradeTable = styled.table`
  width: 100%; border-collapse: collapse; border-radius: 12px; overflow: hidden; font-size: 0.9rem; margin-top: auto;
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#bfdbfe'}; 
  background: transparent;

  th {
    background: linear-gradient(135deg, #1e3a8a, #2563eb); color: white; font-weight: 800; padding: 14px; text-align: left;
    border-bottom: 2px solid ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#1e40af'}; 
  }
  td {
    padding: 12px 14px; font-weight: 700;
    border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#dbeafe'}; 
    color: ${({ $isDarkMode }) => $isDarkMode ? '#93c5fd' : '#1e3a8a'}; 
  }
  tr:last-child td { border-bottom: none; }
`;

/* ================= LOADING / EMPTY STATES ================= */
const CenterState = styled.div` min-height: 60vh; display: grid; place-items: center; padding: 24px; `;
const StateCard = styled.div` width: min(460px, 100%); background: var(--card-bg); border: 1px solid var(--border); border-radius: 24px; padding: 28px; text-align: center; box-shadow: var(--shadow-md); `;
const Spinner = styled.div` width: 46px; height: 46px; margin: 0 auto 18px; border-radius: 50%; border: 4px solid var(--border); border-top-color: #2563eb; animation: spin 0.8s linear infinite; @keyframes spin { to { transform: rotate(360deg); } } `;
const StateTitle = styled.h3` margin: 0; font-size: 1.1rem; color: var(--text-main); `;
const StateText = styled.p` margin: 10px 0 0; color: var(--text-soft); line-height: 1.6; `;
const EmptyState = styled.div` text-align: center; padding: 90px 20px; color: var(--text-soft); background: var(--card-bg); border-radius: 20px; border: 1px dashed var(--border); `;

/* ================= COMPONENT ================= */
const Records = ({ user, collapsed, setCollapsed }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState("");

  // 🔥 GLOBAL THEME HOOK 🔥
  const { isDarkMode } = useTheme();

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const res = await api.get("/appraisal/all");
        setRecords(res.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch records", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRecords();
  }, []);

  const allTabs = useMemo(() => {
    const tabs = [];
    records.forEach((record) => {
      const yearMatch = record.appraisalPeriod.match(/\d{4}/);
      const year = yearMatch ? yearMatch[0] : ""; 
      (record.section2 || []).forEach((m) => {
        const monthName = m.month || "Unknown";
        const displayYear = (year && !monthName.includes(year)) ? ` ${year}` : "";
        tabs.push({
          id: `${record.appraisalPeriod}-${monthName}`,
          period: record.appraisalPeriod,
          month: monthName,
          label: `Performance Record for ${monthName}${displayYear}`,
          record: record, 
          monthData: m   
        });
      });
    });
    return tabs;
  }, [records]);

  const currentTab = useMemo(() => {
    return allTabs.find(tab => tab.id === expandedId) || null;
  }, [allTabs, expandedId]);

  const exportData = useMemo(() => {
    if (!currentTab) return null;
    return {
      appraisalPeriod: currentTab.record.appraisalPeriod,
      selectedMonth: currentTab.month,
      section2: currentTab.monthData || null,
      section3: currentTab.record.section3 || [],
      section4: currentTab.record.section4 || [],
      summary: currentTab.record.summary || {},
      staffFeedback: currentTab.record.staffFeedback || {},
    };
  }, [currentTab]);

  const exportBaseName = `performance-record-${currentTab?.period || "record"}-${currentTab?.month || "month"}`;

  const handleExportJSON = () => {
    if (!exportData) return;
    downloadBlob(JSON.stringify(exportData, null, 2), `${exportBaseName}.json`, "application/json");
  };

  const handleExportTXT = () => {
    if (!exportData) return;
    const txt = `
PERFORMANCE RECORD
Period: ${currentTab.period}
Month: ${currentTab.month}

SUMMARY
Section 2: ${formatValue(exportData.summary?.section2, 0)}
Section 3: ${formatValue(exportData.summary?.section3, 0)}
Section 4: ${formatValue(exportData.summary?.section4, 0)}
Cumulative: ${formatValue(exportData.summary?.cumulative, 0)}
Grade: ${formatValue(exportData.summary?.grade, "—")}
Supervisor's Grade: ${formatValue(exportData.summary?.supervisorGrade, "—")}

CITATION
${formatValue(exportData.summary?.citation)}

SUPERVISOR OVERALL COMMENTS
${formatValue(exportData.staffFeedback?.supervisorAttention)}
`.trim();
    downloadBlob(txt, `${exportBaseName}.txt`, "text/plain;charset=utf-8");
  };

  const handleExportCSV = () => {
    if (!exportData) return;
    const rows = [];
    rows.push(["section", "group", "title", "achievement", "staffActionScore", "staffQualityScore", "supervisorActionScore", "supervisorQualityScore", "staffScore", "supervisorScore", "comments"].map(toCSVValue).join(","));
    downloadBlob(rows.join("\n"), `${exportBaseName}.csv`, "text/csv;charset=utf-8");
  };

  const handlePrintPDF = () => window.print();

  if (loading) {
    return (
      <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
        <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
        <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
        <CenterState><StateCard><Spinner /><StateTitle>Loading records</StateTitle></StateCard></CenterState>
      </Container>
    );
  }
  if (!records.length || allTabs.length === 0) {
    return (
      <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
        <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
        <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
        <Main>
          <EmptyState>No records found yet.</EmptyState>
        </Main>
      </Container>
    );
  }

  return (
    // 🔥 PASS THE THEME STATE TO THE CONTAINER 🔥
    <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
      <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      <DashboardHeader user={user} collapsed={collapsed} title="Performance Records" />
      <Main>
        <HeroSection>
          <HeroPanel>
            <HeroTitle>Records</HeroTitle>
            <HeroText>View your performance records fully displayed per period.</HeroText>
          </HeroPanel>
          <ExportWrap>
            <ExportButton variant="primary" disabled={!expandedId} onClick={handlePrintPDF}>Export PDF</ExportButton>
            <ExportButton variant="secondary" $isDarkMode={isDarkMode} disabled={!expandedId} onClick={handleExportCSV}>Export CSV</ExportButton>
            <ExportButton variant="secondary" $isDarkMode={isDarkMode} disabled={!expandedId} onClick={handleExportTXT}>Export TXT</ExportButton>
          </ExportWrap>
        </HeroSection>

        <RecordList>
          {allTabs.map((tab) => {
            const isExpanded = expandedId === tab.id;
            const recordData = tab.record;
            const monthData = tab.monthData;

            return (
              <RecordItem key={tab.id} $expanded={isExpanded} $isDarkMode={isDarkMode}>
                <RecordHeader $expanded={isExpanded} $isDarkMode={isDarkMode} onClick={() => setExpandedId(isExpanded ? "" : tab.id)}>
                  <RecordHeaderInfo>
                    <RecordHeaderTitle>{tab.label}</RecordHeaderTitle>
                    <RecordHeaderSub>Period: {tab.period}</RecordHeaderSub>
                  </RecordHeaderInfo>
                  <ViewButton $expanded={isExpanded} $isDarkMode={isDarkMode}>{isExpanded ? "Close" : "View"}</ViewButton>
                </RecordHeader>

                {isExpanded && (
                  <DocumentWrapper>
                    
                    {/* SECTION 2 */}
                    <SectionBlock>
                      <SectionHeading variant="red" $isDarkMode={isDarkMode}>
                        <SectionTitle>PERFORMANCE ON GOALS</SectionTitle>
                      </SectionHeading>

                      <SectionTitle style={{ marginBottom: 12, fontSize: '14px', color: 'var(--text-main)' }}>Major Goals - 60 Marks</SectionTitle>
                      <TableWrap variant="red" $isDarkMode={isDarkMode}>
                      <Table>
                          <colgroup>
                            <col style={{ width: "35px" }} />
                            <col style={{ width: "auto" }} />
                            <col style={{ width: "auto" }} />
                            <col style={{ width: "85px" }} />
                            <col style={{ width: "85px" }} />
                            <col style={{ width: "110px" }} />
                            <col style={{ width: "115px" }} />
                            <col style={{ width: "150px" }} />
                          </colgroup>
                          <thead>
                            <tr>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>S/N</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>MAJOR GOALS</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>ACHIEVEMENTS</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>YOUR SCORE ON QUALITY (0-5)</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
                              <ThemedTh variant="red" $isDarkMode={isDarkMode}>SUPERVISOR'S COMMENTS</ThemedTh>
                            </tr>
                          </thead>
                          <tbody>
                            {(monthData?.majorGoals || []).map((goal, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{index + 1}</td>
                                  <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.goal)}</DisabledInput></td>
                                  <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.achievement)}</DisabledInput></td>
                                  <td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffActionScore)}</SmallScore></td>
                                  <td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
                                  <td><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
                                  <td><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
                                  <td>
                                    <textarea 
                                      readOnly 
                                      value={formatValue(goal.supervisorComments)} 
                                      style={{
                                        width: "100%", minHeight: "45px", padding: "6px 8px", 
                                        border: "1px solid var(--input-border)", borderRadius: "6px", 
                                        background: isDarkMode ? "var(--input-bg)" : "#f8fafc", color: "var(--text-main)", 
                                        fontSize: "12px", lineHeight: "1.4", 
                                        resize: "vertical", boxSizing: "border-box", 
                                        outline: "none", fontFamily: "inherit"
                                      }} 
                                    />
                                  </td>
                                </tr>
                                {(goal.weekly || []).map((week, weekIndex) => (
                                  <WeeklyRow key={`${index}-${weekIndex}`} $isDarkMode={isDarkMode}>
                                    <td></td>
                                    <td>
                                      <strong>{formatValue(week.week, `Week ${weekIndex + 1}`)}</strong>
                                      <div style={{ marginTop: 8 }}>{formatValue(week.weeklyGoal)}</div>
                                    </td>
                                    <td>{formatValue(week.weeklyAchievement)}</td>
                                    <td colSpan="5" style={{ opacity: 0.6, fontSize: '10px' }}></td>
                                  </WeeklyRow>
                                ))}
                              </React.Fragment>
                            ))}
                            <ThemedTotalsRow variant="red" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SUM OF SCORES (SS)</td>
                              <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffActionScore), 0)}</td>
                              <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffQualityScore), 0)}</td>
                              <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorActionScore), 0)}</td>
                              <td>{(monthData?.majorGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorQualityScore), 0)}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="red" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SCORE (SS/GOALS)</td>
                              <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td>{(() => { const goals = monthData?.majorGoals || []; const valid = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="red" $isDarkMode={isDarkMode}>
                              <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.majorGoals || []; 
                                const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
                                return ((avgA + avgQ) / 2).toFixed(2);
                              })()}</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.majorGoals || []; 
                                const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
                                return ((avgA + avgQ) / 2).toFixed(2);
                              })()}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="red" $isDarkMode={isDarkMode}>
                              <td colSpan="3">TOTAL SCORE (CS/5 × 60 Marks)</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.majorGoals || []; 
                                const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
                                const cs = (avgA + avgQ) / 2;
                                return ((cs / 5) * 60).toFixed(1);
                              })()} / 60</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.majorGoals || []; 
                                const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
                                const cs = (avgA + avgQ) / 2;
                                return ((cs / 5) * 60).toFixed(1);
                              })()} / 60</td>
                              <td></td>
                            </ThemedTotalsRow>
                          </tbody>
                        </Table>
                      </TableWrap>

                      {/* MOBILE VIEW CARDS FOR MAJOR GOALS */}
                      <CardGrid>
                        {(monthData?.majorGoals || []).map((goal, index) => (
                          <RecordCard variant="red" key={index} $isDarkMode={isDarkMode}>
                            <RecordCardHead>
                              <RecordIndex variant="red" $isDarkMode={isDarkMode}>{index + 1}</RecordIndex>
                              <RecordLabel variant="red" $isDarkMode={isDarkMode}>Major Goal</RecordLabel>
                            </RecordCardHead>
                            <RecordFields>
                              <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
                              <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
                              <CompactScoreGrid>
                                <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
                              </CompactScoreGrid>
                              <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
                              {(goal.weekly || []).map((week, weekIndex) => (
                                <WeeklyCard key={weekIndex} $isDarkMode={isDarkMode}>
                                  <FieldTitle>{formatValue(week.week, `Week ${weekIndex + 1}`)}</FieldTitle>
                                  <div>{formatValue(week.weeklyGoal)}</div>
                                  <div style={{ marginTop: 8, color: "var(--text-soft)" }}>{formatValue(week.weeklyAchievement)}</div>
                                </WeeklyCard>
                              ))}
                            </RecordFields>
                          </RecordCard>
                        ))}
                      </CardGrid>

                      <SectionTitle style={{ marginBottom: 12, fontSize: '14px', color: 'var(--text-main)' }}>Other Goals - 15 Marks</SectionTitle>
                      <TableWrap variant="orange" $isDarkMode={isDarkMode}>
                      <Table>
                          <colgroup>
                            <col style={{ width: "35px" }} />
                            <col style={{ width: "auto" }} />
                            <col style={{ width: "auto" }} />
                            <col style={{ width: "85px" }} />
                            <col style={{ width: "85px" }} />
                            <col style={{ width: "110px" }} />
                            <col style={{ width: "115px" }} />
                            <col style={{ width: "150px" }} />
                          </colgroup>
                          <thead>
                            <tr>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>S/N</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>MAJOR GOALS</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>ACHIEVEMENTS</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>YOUR SCORE ON ACTIONS (0-5)</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>YOUR SCORE ON QUALITY (0-5)</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>SUPERVISOR'S SCORE ON ACTION TAKEN (0-5)</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>SUPERVISOR'S SCORE ON QUALITY OF DELIVERY (0-5)</ThemedTh>
                              <ThemedTh variant="orange" $isDarkMode={isDarkMode}>SUPERVISOR'S COMMENTS</ThemedTh>
                            </tr>
                          </thead>
                          <tbody>
                            {(monthData?.otherGoals || []).map((goal, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.goal)}</DisabledInput></td>
                                <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.achievement)}</DisabledInput></td>
                                <td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffActionScore)}</SmallScore></td>
                                <td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffQualityScore)}</SmallScore></td>
                                <td><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorActionScore)}</SmallScore></td>
                                <td><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorQualityScore)}</SmallScore></td>
                                <td>
                                  <textarea 
                                    readOnly 
                                    value={formatValue(goal.supervisorComments)} 
                                    style={{
                                      width: "100%", minHeight: "45px", padding: "6px 8px", 
                                      border: "1px solid var(--input-border)", borderRadius: "6px", 
                                      background: isDarkMode ? "var(--input-bg)" : "#f8fafc", color: "var(--text-main)", 
                                      fontSize: "12px", lineHeight: "1.4", 
                                      resize: "vertical", boxSizing: "border-box", 
                                      outline: "none", fontFamily: "inherit"
                                    }} 
                                  />
                                </td>
                              </tr>
                            ))}
                            <ThemedTotalsRow variant="orange" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SUM OF SCORES (SS)</td>
                              <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffActionScore), 0)}</td>
                              <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.staffQualityScore), 0)}</td>
                              <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorActionScore), 0)}</td>
                              <td>{(monthData?.otherGoals || []).reduce((acc, goal) => acc + safeNumber(goal.supervisorQualityScore), 0)}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="orange" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SCORE (SS/GOALS)</td>
                              <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td>{(() => { const goals = monthData?.otherGoals || []; const valid = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); return valid.length ? (valid.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / valid.length).toFixed(2) : "0"; })()}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="orange" $isDarkMode={isDarkMode}>
                              <td colSpan="3">COMBINED SCORE (A+Q/2 = CS)</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.otherGoals || []; 
                                const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
                                return ((avgA + avgQ) / 2).toFixed(2);
                              })()}</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.otherGoals || []; 
                                const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
                                return ((avgA + avgQ) / 2).toFixed(2);
                              })()}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="orange" $isDarkMode={isDarkMode}>
                              <td colSpan="3">TOTAL SCORE (CS/5 × 15 Marks)</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.otherGoals || []; 
                                const validA = goals.filter(g => g.staffActionScore !== "" && g.staffActionScore != null && !Number.isNaN(Number(g.staffActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.staffActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.staffQualityScore !== "" && g.staffQualityScore != null && !Number.isNaN(Number(g.staffQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.staffQualityScore), 0) / validQ.length) : 0;
                                const cs = (avgA + avgQ) / 2;
                                return ((cs / 5) * 15).toFixed(1);
                              })()} / 15</td>
                              <td colSpan="2">{(() => { 
                                const goals = monthData?.otherGoals || []; 
                                const validA = goals.filter(g => g.supervisorActionScore !== "" && g.supervisorActionScore != null && !Number.isNaN(Number(g.supervisorActionScore))); 
                                const avgA = validA.length ? (validA.reduce((acc, g) => acc + safeNumber(g.supervisorActionScore), 0) / validA.length) : 0;
                                const validQ = goals.filter(g => g.supervisorQualityScore !== "" && g.supervisorQualityScore != null && !Number.isNaN(Number(g.supervisorQualityScore))); 
                                const avgQ = validQ.length ? (validQ.reduce((acc, g) => acc + safeNumber(g.supervisorQualityScore), 0) / validQ.length) : 0;
                                const cs = (avgA + avgQ) / 2;
                                return ((cs / 5) * 15).toFixed(1);
                              })()} / 15</td>
                              <td></td>
                            </ThemedTotalsRow>
                          </tbody>
                        </Table>
                      </TableWrap>

                      {/* MOBILE VIEW CARDS FOR OTHER GOALS */}
                      <CardGrid>
                        {(monthData?.otherGoals || []).map((goal, index) => (
                          <RecordCard variant="orange" key={index} $isDarkMode={isDarkMode}>
                            <RecordCardHead>
                              <RecordIndex variant="orange" $isDarkMode={isDarkMode}>{index + 1}</RecordIndex>
                              <RecordLabel variant="orange" $isDarkMode={isDarkMode}>Other Goal</RecordLabel>
                            </RecordCardHead>
                            <RecordFields>
                              <FieldBlock><FieldTitle>Goal</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.goal)}</DisabledInput></FieldBlock>
                              <FieldBlock><FieldTitle>Achievement</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.achievement)}</DisabledInput></FieldBlock>
                              <CompactScoreGrid>
                                <FieldBlock><FieldTitle>Your Action Score</FieldTitle><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffActionScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Your Quality Score</FieldTitle><SmallScore $isDarkMode={isDarkMode}>{scoreValue(goal.staffQualityScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Supervisor Action</FieldTitle><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorActionScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Supervisor Quality</FieldTitle><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(goal.supervisorQualityScore)}</SmallScore></FieldBlock>
                              </CompactScoreGrid>
                              <FieldBlock><FieldTitle>Supervisor's  Comments</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(goal.supervisorComments)}</DisabledInput></FieldBlock>
                            </RecordFields>
                          </RecordCard>
                        ))}
                      </CardGrid>
                    </SectionBlock>

                    {/* SECTION 3 */}
                    <SectionBlock>
                      <SectionHeading variant="purple" $isDarkMode={isDarkMode}>
                        <SectionTitle>WORK ETHIC & LEADERSHIP</SectionTitle>
                      </SectionHeading>
                      <TableWrap variant="purple" $isDarkMode={isDarkMode}>
                        <Table>
                          <colgroup>
                            <col style={{ width: "4%" }} />
                            <col style={{ width: "16%" }} />
                            <col style={{ width: "22%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "19%" }} />
                            <col style={{ width: "12%" }} />
                            <col style={{ width: "19%" }} />
                          </colgroup>
                          <thead>
                            <tr>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>S/N</ThemedTh>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>ATTRIBUTE</ThemedTh>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>DESCRIPTION</ThemedTh>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>YOUR SCORE</ThemedTh>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>YOUR COMMENTS</ThemedTh>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>SUPERVISOR&apos;S<br/>SCORE</ThemedTh>
                              <ThemedTh variant="purple" $isDarkMode={isDarkMode}>SUPERVISOR'S   COMMENTS</ThemedTh>
                            </tr>
                          </thead>
                          <tbody>
                            {(recordData?.section3 || []).map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.attribute)}</DisabledInput></td>
                                <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.description)}</DisabledInput></td>
                                <td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(item.staffScore)}</SmallScore></td>
                                <td>
                                  <textarea 
                                    readOnly 
                                    value={formatValue(item.staffComments)} 
                                    style={{
                                      width: "100%", minHeight: "45px", padding: "6px 8px", 
                                      border: "1px solid var(--input-border)", borderRadius: "6px", 
                                      background: isDarkMode ? "var(--input-bg)" : "#f8fafc", color: "var(--text-main)", 
                                      fontSize: "12px", lineHeight: "1.4", 
                                      resize: "vertical", boxSizing: "border-box", 
                                      outline: "none", fontFamily: "inherit"
                                    }} 
                                  />
                                </td>
                                <td><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(item.supervisorScore)}</SmallScore></td>
                                <td>
                                  <textarea 
                                    readOnly 
                                    value={formatValue(item.supervisorComments)} 
                                    style={{
                                      width: "100%", minHeight: "45px", padding: "6px 8px", 
                                      border: "1px solid var(--input-border)", borderRadius: "6px", 
                                      background: isDarkMode ? "var(--input-bg)" : "#f8fafc", color: "var(--text-main)", 
                                      fontSize: "12px", lineHeight: "1.4", 
                                      resize: "vertical", boxSizing: "border-box", 
                                      outline: "none", fontFamily: "inherit"
                                    }} 
                                  />
                                </td>
                              </tr>
                            ))}
                            <ThemedTotalsRow variant="purple" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SUM OF SCORES (SS)</td>
                              <td>{(recordData?.section3 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
                              <td></td>
                              <td>{(recordData?.section3 || []).reduce((acc, item) => { const num = Number(item.supervisorScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="purple" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SCORE (SS/10)</td>
                              <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
                              <td></td>
                              <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="purple" $isDarkMode={isDarkMode}>
                              <td colSpan="3">TOTAL SCORE (SCORE/5 × 15 Marks)</td>
                              <td colSpan="2">{formatValue(recordData?.summary?.section3, 0)} / 20</td>
                              <td>{(() => { const items = recordData?.section3 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); const avg = valid.length ? (sum / valid.length) : 0; return ((avg / 5) * 20).toFixed(1); })()} / 20</td>
                              <td></td>
                            </ThemedTotalsRow>
                          </tbody>
                        </Table>
                      </TableWrap>

                      {/* MOBILE VIEW CARDS FOR WORK ETHIC */}
                      <CardGrid>
                        {(recordData?.section3 || []).map((item, index) => (
                          <RecordCard variant="purple" key={index} $isDarkMode={isDarkMode}>
                            <RecordCardHead>
                              <RecordIndex variant="purple" $isDarkMode={isDarkMode}>{index + 1}</RecordIndex>
                              <RecordLabel variant="purple" $isDarkMode={isDarkMode}>Work Ethic</RecordLabel>
                            </RecordCardHead>
                            <RecordFields>
                              <FieldBlock><FieldTitle>Attribute</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
                              <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.description)}</DisabledInput></FieldBlock>
                              <CompactScoreGrid>
                                <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore $isDarkMode={isDarkMode}>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
                              </CompactScoreGrid>
                              <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
                              <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
                            </RecordFields>
                          </RecordCard>
                        ))}
                      </CardGrid>
                    </SectionBlock>

                    {/* SECTION 4 */}
                    <SectionBlock>
                      <SectionHeading variant="green" $isDarkMode={isDarkMode}>
                        <SectionTitle>COMPLIANCE</SectionTitle>
                      </SectionHeading>
                      <TableWrap variant="green" $isDarkMode={isDarkMode}>
                      <Table>
                          <colgroup>
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "25%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "18%" }} />
                            <col style={{ width: "12%" }} />
                            <col style={{ width: "17%" }} />
                          </colgroup>
                          <thead>
                            <tr>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>S/N</ThemedTh>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>PROTOCOL</ThemedTh>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>DESCRIPTION</ThemedTh>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>YOUR SCORE</ThemedTh>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>YOUR COMMENTS</ThemedTh>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>SUPERVISOR'S SCORE</ThemedTh>
                              <ThemedTh variant="green" $isDarkMode={isDarkMode}>SUPERVISOR'S COMMENTS</ThemedTh>
                            </tr>
                          </thead>
                          <tbody>
                            {(recordData?.section4 || []).map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.attribute)}</DisabledInput></td>
                                <td><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.description)}</DisabledInput></td>
                                <td><SmallScore $isDarkMode={isDarkMode}>{scoreValue(item.staffScore)}</SmallScore></td>
                                <td>
                                  <textarea 
                                    readOnly 
                                    value={formatValue(item.staffComments)} 
                                    style={{
                                      width: "100%", minHeight: "45px", padding: "6px 8px", 
                                      border: "1px solid var(--input-border)", borderRadius: "6px", 
                                      background: isDarkMode ? "var(--input-bg)" : "#f8fafc", color: "var(--text-main)", 
                                      fontSize: "12px", lineHeight: "1.4", 
                                      resize: "vertical", boxSizing: "border-box", 
                                      outline: "none", fontFamily: "inherit"
                                    }} 
                                  />
                                </td>
                                <td><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(item.supervisorScore)}</SmallScore></td>
                                <td>
                                  <textarea 
                                    readOnly 
                                    value={formatValue(item.supervisorComments)} 
                                    style={{
                                      width: "100%", minHeight: "45px", padding: "6px 8px", 
                                      border: "1px solid var(--input-border)", borderRadius: "6px", 
                                      background: isDarkMode ? "var(--input-bg)" : "#f8fafc", color: "var(--text-main)", 
                                      fontSize: "12px", lineHeight: "1.4", 
                                      resize: "vertical", boxSizing: "border-box", 
                                      outline: "none", fontFamily: "inherit"
                                    }} 
                                  />
                                </td>
                              </tr>
                            ))}
                            <ThemedTotalsRow variant="green" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SUM OF SCORES (SS)</td>
                              <td>{(recordData?.section4 || []).reduce((acc, item) => { const num = Number(item.staffScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
                              <td></td>
                              <td>{(recordData?.section4 || []).reduce((acc, item) => { const num = Number(item.supervisorScore); return Number.isNaN(num) ? acc : acc + num; }, 0)}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="green" $isDarkMode={isDarkMode}>
                              <td colSpan="3">SCORE (SS/13)</td>
                              <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => !Number.isNaN(Number(x.staffScore))); const sum = valid.reduce((acc, item) => acc + Number(item.staffScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
                              <td></td>
                              <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); return valid.length ? (sum / valid.length).toFixed(2) : "0"; })()}</td>
                              <td></td>
                            </ThemedTotalsRow>
                            <ThemedTotalsRow variant="green" $isDarkMode={isDarkMode}>
                              <td colSpan="3">TOTAL SCORE (SCORE/5 × 10 Marks)</td>
                              <td colSpan="2">{formatValue(recordData?.summary?.section4, 0)} / 10</td>
                              <td>{(() => { const items = recordData?.section4 || []; const valid = items.filter((x) => x.supervisorScore !== "" && x.supervisorScore != null && !Number.isNaN(Number(x.supervisorScore))); const sum = valid.reduce((acc, item) => acc + Number(item.supervisorScore), 0); const avg = valid.length ? (sum / valid.length) : 0; return ((avg / 5) * 10).toFixed(1); })()} / 10</td>
                              <td></td>
                            </ThemedTotalsRow>
                          </tbody>
                        </Table>
                      </TableWrap>

                      {/* MOBILE VIEW CARDS FOR COMPLIANCE */}
                      <CardGrid>
                        {(recordData?.section4 || []).map((item, index) => (
                          <RecordCard variant="green" key={index} $isDarkMode={isDarkMode}>
                            <RecordCardHead>
                              <RecordIndex variant="green" $isDarkMode={isDarkMode}>{index + 1}</RecordIndex>
                              <RecordLabel variant="green" $isDarkMode={isDarkMode}>Compliance</RecordLabel>
                            </RecordCardHead>
                            <RecordFields>
                              <FieldBlock><FieldTitle>Protocol</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.attribute)}</DisabledInput></FieldBlock>
                              <FieldBlock><FieldTitle>Description</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.description)}</DisabledInput></FieldBlock>
                              <CompactScoreGrid>
                                <FieldBlock><FieldTitle>Your Score</FieldTitle><SmallScore $isDarkMode={isDarkMode}>{scoreValue(item.staffScore)}</SmallScore></FieldBlock>
                                <FieldBlock><FieldTitle>Supervisor Score</FieldTitle><SmallScore muted $isDarkMode={isDarkMode}>{scoreValue(item.supervisorScore)}</SmallScore></FieldBlock>
                              </CompactScoreGrid>
                              <FieldBlock><FieldTitle>Your Comments</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.staffComments)}</DisabledInput></FieldBlock>
                              <FieldBlock><FieldTitle>Supervisor Comments</FieldTitle><DisabledInput $isDarkMode={isDarkMode}>{formatValue(item.supervisorComments)}</DisabledInput></FieldBlock>
                            </RecordFields>
                          </RecordCard>
                        ))}
                      </CardGrid>
                    </SectionBlock>

                    {/* CITATIONS SECTION (MOVED ABOVE SUMMARY) */}
                    <SectionBlock>
                      <SectionHeading variant="blue" $isDarkMode={isDarkMode}>
                        <SectionTitle>CITATIONS OF YOUR ACHIEVEMENTS</SectionTitle>
                      </SectionHeading>
                      <TextBlock style={{ minHeight: "80px" }} $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.citation)}</TextBlock>
                    </SectionBlock>

                    {/* NEW SPLIT SUMMARY SECTION */}
                    <SectionBlock>
                      <SectionHeading variant="blue" $isDarkMode={isDarkMode}>
                        <SectionTitle>SUMMARY</SectionTitle>
                      </SectionHeading>
                      
                      {/* Set columns to 1fr 1fr to ensure both breakdowns are perfectly equal in width */}
                      <SummaryGrid style={{ gridTemplateColumns: "1fr 1fr" }}>
                        
                        {/* LEFT COLUMN: YOUR SCORES & GRADE */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                          <SummaryCard>
                            <SummaryCardTitle>Your Total Score Breakdown</SummaryCardTitle>
                            <ScoreList>
                              <ScoreRow variant="red" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="red" $isDarkMode={isDarkMode}>Goals</ScoreLabel>
                                <ScoreValueBox variant="red" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.section2, 0)}</ScoreValueBox>
                              </ScoreRow>
                              <ScoreRow variant="purple" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="purple" $isDarkMode={isDarkMode}>Ethics</ScoreLabel>
                                <ScoreValueBox variant="purple" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.section3, 0)}</ScoreValueBox>
                              </ScoreRow>
                              <ScoreRow variant="green" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="green" $isDarkMode={isDarkMode}>Compliance</ScoreLabel>
                                <ScoreValueBox variant="green" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.section4, 0)}</ScoreValueBox>
                              </ScoreRow>
                              <ScoreRow variant="dark" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="dark" $isDarkMode={isDarkMode}>Your Performance Score</ScoreLabel>
                                <ScoreValueBox variant="dark" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.cumulative, 0)}</ScoreValueBox>
                              </ScoreRow>
                            </ScoreList>
                          </SummaryCard>

                          <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
                            <div style={{ fontSize: 13, fontWeight: 800, color: "var(--text-soft)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Your Grade</div>
                            <BigGrade>{formatValue(recordData?.summary?.grade, "—")}</BigGrade>
                          </SummaryCard>
                        </div>

                        {/* RIGHT COLUMN: SUPERVISOR SCORES & GRADE */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                          <SummaryCard>
                            <SummaryCardTitle>Supervisor's Score Breakdown</SummaryCardTitle>
                            <ScoreList>
                              {/* Assumes backend passes supervisorSection2, etc. If not, it falls back to "—" */}
                              <ScoreRow variant="red" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="red" $isDarkMode={isDarkMode}>Goals</ScoreLabel>
                                <ScoreValueBox variant="red" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.supervisorSection2, "—")}</ScoreValueBox>
                              </ScoreRow>
                              <ScoreRow variant="purple" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="purple" $isDarkMode={isDarkMode}>Ethics</ScoreLabel>
                                <ScoreValueBox variant="purple" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.supervisorSection3, "—")}</ScoreValueBox>
                              </ScoreRow>
                              <ScoreRow variant="green" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="green" $isDarkMode={isDarkMode}>Compliance</ScoreLabel>
                                <ScoreValueBox variant="green" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.supervisorSection4, "—")}</ScoreValueBox>
                              </ScoreRow>
                              <ScoreRow variant="dark" $isDarkMode={isDarkMode}>
                                <ScoreLabel variant="dark" $isDarkMode={isDarkMode}>Supervisor Cumulative</ScoreLabel>
                                <ScoreValueBox variant="dark" $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.supervisorCumulative, "—")}</ScoreValueBox>
                              </ScoreRow>
                            </ScoreList>
                          </SummaryCard>

                          <SummaryCard style={{ alignItems: "center", textAlign: "center" }}>
                            <div style={{ fontSize: 13, fontWeight: 800, color: "var(--text-soft)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "8px" }}>Supervisor Grade</div>
                            <BigGrade style={{ color: isDarkMode ? "#2dd4bf" : "#0f766e" }}>{formatValue(recordData?.summary?.supervisorGrade, "—")}</BigGrade>
                          </SummaryCard>
                        </div>
                      </SummaryGrid>

                      {/* GRADING SCALE (MOVED TO BOTTOM OF SUMMARY) */}
                      <SummaryCard style={{ marginTop: '18px' }}>
                        <SummaryCardTitle>Grading Scale</SummaryCardTitle>
                        <GradeTable $isDarkMode={isDarkMode}>
                          <thead><tr><th>SCORE RANGE</th><th>GRADE</th></tr></thead>
                          <tbody>
                            <tr><td>80% - Above</td><td>A</td></tr>
                            <tr><td>70% - 79%</td><td>B</td></tr>
                            <tr><td>60% - 69%</td><td>C</td></tr>
                            <tr><td>50% - 59%</td><td>D</td></tr>
                            <tr><td>49% - Below</td><td>E</td></tr>
                          </tbody>
                        </GradeTable>
                      </SummaryCard>
                    </SectionBlock>

                    <SectionBlock>
                      <SectionHeading variant="blue" $isDarkMode={isDarkMode}>
                        <SectionTitle>SUPERVISOR&apos;S OVERALL COMMENTS</SectionTitle>
                      </SectionHeading>
                      <TextBlock $isDarkMode={isDarkMode}>{formatValue(recordData?.staffFeedback?.supervisorAttention)}</TextBlock>
                    </SectionBlock>

                    {/* NEW HEAD OF DEPARTMENT COMMENTS SECTION */}
                    <SectionBlock>
                      <SectionHeading variant="blue" $isDarkMode={isDarkMode}>
                        <SectionTitle>HEAD OF DEPARTMENT&apos;S OVERALL COMMENTS</SectionTitle>
                      </SectionHeading>
                      <TextBlock $isDarkMode={isDarkMode}>{formatValue(recordData?.summary?.hodOverallComments)}</TextBlock>
                    </SectionBlock>

      
                

                  </DocumentWrapper>
                )}
              </RecordItem>
            );
          })}
        </RecordList>
         <Footer />
      </Main>
    </Container>
  );
};

export default Records;